import { useFormik } from "formik";
import React, { useEffect, useMemo, useRef, useState } from "react";
import * as Yup from "yup";
import $ from "jquery";
import { FORM_DATE_TIME_FORMAT, FORM_TIME_FORMAT, IMAGE_URL, TABLE_DATE_FORMAT, TABLE_TIME_FORMAT } from "../../../../utils/Constants";
import Select from "react-select";
import {
  GetIntakeDetails,
  GetQuestionsByQuiz,
  GetQuiz,
  getAssignedGrademixViaAssessment,
  getSickAssessmentStudentList,
  getSupplementaryStdList,
  lockedProgrammes,
} from "../../../../services/CourseService";
import {
  getOverrideAssessments,
  SendAssessmentInstruction,
  AddAssessment,
  GetAssessmentsData,
  FetchAssessmentDetails
} from "../../../../services/AssessmentService";
import Swal from "sweetalert2";
import { Link, useHistory, useParams } from "react-router-dom";
import HtmlInputEditor from "../../../common/HtmlInputEditor";
import {
  convertFromRaw,
  convertToRaw,
  EditorState,
} from "draft-js";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import PermissionsGate from "../../../../utils/permissionGate";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { myCompare } from "../../../common/MyCompare";
import { CheckJSONString } from "../../../common/CheckJSONString";
import draftToHtml from "draftjs-to-html";
import { TrimText } from "../../../common/TrimText";
import AddQuizzTable from "./AddQuizzTable";
import { setAssessmentName } from "../../../../store/actions";
import ListOfTemplateModal from "../../CourseGradeSettings/ListOfTemplateModal";
import { GradeLetterTemplateList } from "../../../../services/GradeSettingService";
import ProgrammeGradeMixModal from "../../Programs/ProgrammeGradeMixModal";
import LinkCourseModal from "./LinkCourseModal";
import PopupComponent from "../../../common/PopupComponent";
import { InitialRender } from "../../../common/Helper";
import Hover from '../../../common/Hover';
import { RenderAssessmentStatus, RenderQuizAttemptResultStatus, RenderStudentStatus } from "../../../../utils/CommonStatusItems";
import DataTableComponentFrontPagination from "../../../common/DataTableComponentFrontPagination";
import { RenderAssessmentType } from "../../../../utils/CommonGroupingItem";
import Dropzone from "react-dropzone";
import formatUrl from "../../../common/formatUrl";
import { handleUploadToS3BucketUrl } from "../../../common/uploadTOS3BucketUrl";
import { resolveObjectStorageUrl } from "../../../../utils/objectStorage";
import { handleGradesLocked } from "../../../../utils/commonFunction";
import axios from "axios";
import { tokens } from "../../../../public/tokens";
import EmbeddedPdfPreview from "../../../library/EmbeddedPdfPreview";
import * as pdfjsLib from "pdfjs-dist";
import styled from "styled-components";
import TextInput from "../../../library/TextInput";
import SelectDropdown from "../../../library/SelectDropdown";
import MultiSelectDropdown from "../../../library/MultiSelectDropdown";
import DateInput from "../../../library/DateInput";
import Checkbox from "../../../library/Checkbox";
import Button from "../../../library/Button";
import CheckboxCardGroup from "../../../library/CheckboxCardGroup";
import CheckboxCard from "../../../library/CheckboxCard";

import { StyledAttachedFileContainer, StyledEmbeddedPdfInfo, StyledEmbeddedPdfInfoContent, StyledEmbeddedPdfFieldCount, StyledEmbeddedPdfDescription, StyledPreviewButton } from "./EmbeddedPdf.styles";

/**
 * Uploads a brief or memo File to Cloudflare R2 and returns the object key.
 * @param {File} file Browser File from the assessment form
 * @param {string} kind "brief" or "demo"
 * @param {{intakeId?: string|number, courseName?: string, assessmentId?: string|number, assessmentName?: string}} location Intake + assessment folders
 * @returns {Promise<{path: string, size: number, storageProvider: string}|null>}
 */
async function uploadAssessmentDocumentToR2(file, kind, location) {
  try {
    const fileExtension = file.name.split(".").pop();
    const sanitizedBaseName = file.name
      .replace(/\.[^/.]+$/, "")
      .replace(/[\t\n\r\f\v]/g, " ")
      .replace(/[^a-zA-Z0-9._\-]/g, "")
      .replace(/\s+/g, " ")
      .trim();
    const sanitizeFolderName = (value, fallbackName) => {
      const cleanedName = String(value || "")
        .replace(/[\t\n\r\f\v]/g, " ")
        .replace(/[\\/]/g, "-")
        .replace(/\s+/g, " ")
        .trim();
      return cleanedName || fallbackName;
    };
    const intakeFolder = `${location?.intakeId || "intake"}_${sanitizeFolderName(location?.courseName, "course")}`;
    const assessmentFolder = location?.assessmentId
      ? `${location.assessmentId}_${sanitizeFolderName(location?.assessmentName, "assessment")}`
      : `new_${sanitizeFolderName(location?.assessmentName, "assessment")}`;
    const objectKey = `Assessments/${intakeFolder}/${assessmentFolder}/${kind}/${sanitizedBaseName}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}.${fileExtension}`;
    // Phase 2 write: brief/memo → Cloudflare R2 (storageProvider "2"; was local Library multipart)
    const uploadedRows = await handleUploadToS3BucketUrl(
      [{ file_name: objectKey, file_type: file.type, storageProvider: "2" }],
      [file],
      { storageProvider: "2" }
    );
    const uploadedRow = uploadedRows?.[0];
    if (!uploadedRow?.path) {
      return null;
    }
    return {
      path: uploadedRow.path,
      size: file.size,
      storageProvider: uploadedRow.storageProvider || "2",
    };
  } catch (error) {
    console.log("AssessmentForm.js->uploadAssessmentDocumentToR2->Error", error);
    throw error;
  }
}

/**
 * Dual-read href for an existing brief/memo: R2/S3 by sticky note, else Library/corona.
 * @param {string} storedPath DB path or object key
 * @param {string|number|null|undefined} providerFlag pathUploadedFrom / pathMarkingUploadedFrom
 * @returns {string}
 */
function getAssignmentDocumentHref(storedPath, providerFlag) {
  if (!storedPath) {
    return "";
  }
  if (typeof storedPath !== "string") {
    return "";
  }
  const provider = String(providerFlag ?? "");
  // Phase 2 dual-read: 1 = AWS S3, 2 = Cloudflare R2
  if (provider === "1" || provider === "2") {
    return resolveObjectStorageUrl(storedPath, provider);
  }
  // --- AWS S3 hostname / corona only (before Phase 2 dual-read) ---
  // if (storedPath.includes("blob") || storedPath.startsWith("https://s3.af-south-1.amazonaws.com/")) {
  //   return storedPath;
  // }
  // return formatUrl(storedPath);
  if (
    storedPath.includes("blob") ||
    storedPath.startsWith("https://s3.af-south-1.amazonaws.com/") ||
    /^https?:\/\//i.test(storedPath)
  ) {
    return storedPath;
  }
  return formatUrl(storedPath);
}

const AssessmentForm = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state);
  const { id, tab, type, subId, subTab } = useParams();
  const [assessmentType, setAssessmentType] = useState([]);
  const [moderatorAndMarker, setModeratorAndMarker] = useState([]);
  const [moderatorSelected, setModeratorSelected] = useState([]);
  const [assessmentTypeSelected, setassessmentTypeSelected] = useState();
  const [gradeSelected, setGradeSelected] = useState();
  const [assessmentFile, setAssessmentFile] = useState();
  const [gradeType, setGradeType] = useState([]);
  const [gradeMixGradeType, setGradeMixGradeType] = useState([]);
  const [assessmentFileName, setAssessmentFileName] = useState();
  const [memoFile, setMemoFile] = useState(null);
  const [memofileName, setMemofileName] = useState();
  const [editorState, setEditorState] = useState("");
  const [assessmentDetails, setAssessmentDetails] = useState({});
  const [selectedDomain, setSelectedDomain] = useState([]);
  const [loading, setLoading] = useState(false);
  const [quizTotal, setQuizTotal] = useState("");
  const [quizLabel, setQuizLabel] = useState("");
  const [assessmentLoad, setAssessmentLoad] = useState(false);
  const [apiDataLoaded, setApiDataLoaded] = useState(false);
  const [isDurationDisabled, setIsDurationDisabled] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [selectedGradeMixTemplate, setSelectedGradeMixTemplate] = useState({});
  const [statusAvailableList, setStatusAvailableList] = useState([]);
  const [courseResultAvailableList, setCourseResultAvailableList] = useState([]);
  const [statusAssignedList, setStatusAssignedList] = useState([]);
  const [courseResultAssignedList, setCourseResultAssignedList] = useState([])
  const [statusAssigned, setStatusAssigned] = useState({ arr: [], checkObj: {} })
  const [courseResultAssigned, setCourseResultAssigned] = useState({ arr: [], checkObj: {} })
  const [statusAvailable, setStatusAvailable] = useState({ arr: [], checkObj: {} });
  const [courseResultAvailable, setCourseResultAvailable] = useState({ arr: [], checkObj: {} });
  const [searchAssigned, setSearchAssigned] = useState("");
  const [availableStudentList, setAvailableStudentList] = useState([])
  const [availableSearch, setAvailableSearch] = useState("");
  const [availableLoading, setAvailableLoading] = useState(false);
  const [assignedStudentList, setAssignedStudentList] = useState([])
  const [assignloading, setAssignloading] = useState(false);
  const [overrideAssessList, setOverrideAssessList] = useState([]);
  const [overrideSearch, setOverrideSearch] = useState("");
  const [overrideLoading, setOverrideLoading] = useState(false);
  const [overrideStatusList, setOverrideStatusList] = useState([]);
  const [overrideStatus, setOverrideStatus] = useState({ arr: [], checkObj: {} });
  const [overrideAssessTypeList, setOverrideAssessTypeList] = useState([]);
  const [overrideAssessType, setOverrideAssessType] = useState({ arr: [], checkObj: {} });
  const [refresh, setRefresh] = useState(false);
  const [checkedAllRows, setCheckedAllRows] = useState([]);
  const [tempCheckedAllData, setTempCheckedAllData] = useState([]);
  const [lettertemplateIndex, setLettertemplateIndex] = useState();
  const [reload, setReload] = useState(false);
  const [gradeMixError, setGradeMixError] = useState([]);
  const [courseError, setCourseError] = useState([]);
  const [touchedStates, setTouchedStates] = useState([]);
  const [assignLoading, setAssignLoading] = useState(false)
  const [overrideMarkFor, setOverrideMarkFor] = useState("")
  const [selectedStudentId, setSelectedStudentId] = useState();
  const [appealReason, setAppealReason] = useState('');
  const [studentMessage, setStudentMessage] = useState('');
  const [selectedFileForAppeal, setSelectedFileForAppeal] = useState([]);
  const [appealError, setAppealError] = useState("");
  const [newAssignee, setNewAssignee] = useState([]);
  const initialSickStudentIdsRef = useRef([]);
  const [overRideId, setOverRideId] = useState();
  const [linkCourseData, setLinkCourseData] = useState([]);
  const [checkLetterTemplateCourse, setCheckLetterTemplateCourse] = useState(false)
  const [linkCheckedAllRows, setLinkCheckedAllRows] = useState([]);
  const [intakeDetails, setIntakeDetails] = useState({});
  const [handleRefreshCourseList, setHandleRefreshCourseList] = useState(Date.now());
  const [letterTemplateCourse, setLetterTemplateCourse] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState({});
  const hasFetchedRef = useRef(false);
  const assessmentFileInputRef = useRef(null);
  const memoFileInputRef = useRef(null);
  const [overrideSelected, setOverrideSelected] = useState({});
  const [letterTemplateOption, setLetterTemplateOption] = useState([]);
  const [isFetchOption, setIsFetchOption] = useState(false);
  const [linkedProgrammes, setLinkedProgrammes] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const prevIntakeIdsRef = useRef('');
  /**
    Boolean that is true if we are past the open date and the action is open (which means edit view)
  */
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [showPdfPreview, setShowPdfPreview] = useState(false);
  const [embeddedPdfFieldCount, setEmbeddedPdfFieldCount] = useState(0);

  // One more state:
  const [embeddedPdfFieldCheckComplete, setEmbeddedPdfFieldCheckComplete] = useState(false);

  const assessmentActive = (type === "open" && assessmentDetails &&
    assessmentDetails.openDateAndTime &&
    assessmentDetails.openDateAndTime !== "NaN"
    && Number(assessmentDetails.openDateAndTime) <= moment().valueOf());
  useEffect(() => {
    if (quizTotal) {
      let arr = tempCheckedAllData.map(item => ({ ...item, assessment_total: quizTotal }))
      setTempCheckedAllData([...arr])
    }
  }, [checkedAllRows])

  useEffect(() => {
    if (quizTotal) {
      let arr = linkCourseData.map(item => ({ ...item, assessment_total: quizTotal }))
      setLinkCourseData([...arr])
    }
  }, [quizTotal, linkCheckedAllRows])

  useEffect(() => {
    let newData = letterTemplateCourse ? linkCourseData : tempCheckedAllData;

    if (newData.length && (Object.keys(selectedCourse).length > 0 || letterTemplateCourse == true)) {
      setLinkCourseData((prevData) => {
        const newData = [...prevData];
        newData[lettertemplateIndex] = {
          ...newData[lettertemplateIndex],
          selectedTemplate: selectedCourse,
        };
        let templateGrdaeMixPassMarkArr = [];
        let templateGrdaeMixArray =
          newData[lettertemplateIndex].selectedTemplate?.gradeOptions?.length &&
          newData[lettertemplateIndex].selectedTemplate?.gradeOptions.map(
            (item) => {
              templateGrdaeMixPassMarkArr.push({
                value: item?.id,
                label: item?.text,
              });
              newData[lettertemplateIndex].templateOptions = templateGrdaeMixPassMarkArr;
            }
          );
        return newData;
      });
    } else if (newData.length && newData[lettertemplateIndex]?.selectedTemplate) {
      setTempCheckedAllData((prevData) => {
        const newData = [...prevData];
        newData[lettertemplateIndex].selectedTemplate =
          selectedGradeMixTemplate;
        let templateGrdaeMixPassMarkArr = [];
        let templateGrdaeMixArray =
          newData[lettertemplateIndex].selectedTemplate?.gradeOptions?.length &&
          newData[lettertemplateIndex].selectedTemplate?.gradeOptions.map(
            (item) => {
              templateGrdaeMixPassMarkArr.push({
                value: item?.id,
                label: item?.text,
              });
              newData[lettertemplateIndex].templateOptions =
                templateGrdaeMixPassMarkArr;
            }
          );
        return newData;
      });
    } else if (newData.length) {
      if (!letterTemplateCourse) {
        setTempCheckedAllData((prevData) => {
          const newData = [...prevData];
          newData[lettertemplateIndex] = {
            ...newData[lettertemplateIndex],
            selectedTemplate: selectedGradeMixTemplate,
          };
          let templateGrdaeMixPassMarkArr = [];
          let templateGrdaeMixArray =
            newData[lettertemplateIndex].selectedTemplate?.gradeOptions?.length &&
            newData[lettertemplateIndex].selectedTemplate?.gradeOptions.map(
              (item) => {
                templateGrdaeMixPassMarkArr.push({
                  value: item?.id,
                  label: item?.text,
                });
                newData[lettertemplateIndex].templateOptions =
                  templateGrdaeMixPassMarkArr;
              }
            );
          return newData;
        });
      }
    }
  }, [selectedGradeMixTemplate, reload, selectedCourse, letterTemplateCourse]);

  let templatePassMarkArr = [];
  let templateArray =
    selectedTemplate?.gradeOptions?.length &&
    selectedTemplate?.gradeOptions.map((item) => {
      templatePassMarkArr.push({
        value: item?.id,
        label: item?.text,
      });
    });

  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };


  const sortingName = (rowA, rowB) => {
    const name1 = rowA.name ? rowA.name.toString() : "";
    const name2 = rowB.name ? rowB.name.toString() : "";
    return name1.localeCompare(name2);
  };


  const sortingStudentName = (rowA, rowB) => {
    const name1 = rowA.full_name ? rowA.full_name.toString() : "";
    const name2 = rowB.full_name ? rowB.full_name.toString() : "";
    return name1.localeCompare(name2);
  };

  const GetLetterTemplateOption = async () => {
    if (isFetchOption || letterTemplateOption.length) return letterTemplateOption;

    try {
      const res = await GradeLetterTemplateList({ exportStatus: true });
      setLetterTemplateOption(res);
      setIsFetchOption(true);
      return res;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  const stdNoSort = (rowA, rowB) => {
    const name1 = rowA?.student_crm_id ? +rowA.student_crm_id : 0;
    const name2 = rowB?.student_crm_id ? +rowB.student_crm_id : 0;
    return name1 - name2;
  };


  const passMarkRobotArr = [
    {
      label: "Red",
      value: 0,
    },
    {
      label: "Yellow",
      value: 49,
    },
    {
      label: "Green",
      value: 100,
    },
  ]

  useEffect(() => {
    if (overRideId || assessmentTypeSelected == 8) {

      let data = {
        intake_id: id,
        assessment_id: assessmentDetails?.id || subId,
        override_mark_ass_id: overRideId,
      }
      if (assessmentTypeSelected == 8) {
        setAvailableLoading(true)
        getSupplementaryStdList(data).then(res => {
          setAvailableStudentList(res.data.list)
          setCourseResultAvailableList(res.data.course_result)
          setStatusAvailableList(res.data.status)
        }
        ).catch(err => {
          console.error("error", err)
        }).finally(() => setAvailableLoading(false))
      } else if (assessmentTypeSelected == 9) {
        setAvailableLoading(true)

        getSickAssessmentStudentList(data).then(res => {
          setAvailableStudentList(res.data.list || [])
          setCourseResultAvailableList(res.data.course_result || [])
          setStatusAvailableList(res.data.status || [])
        }
        ).catch(err => {
          console.error("error", err)
        }).finally(() => setAvailableLoading(false))
      }
    }
  }, [refresh, assessmentTypeSelected, overRideId])

  useEffect(() => {
    if (type !== "duplicate" && type !== "add") {

      let data = {
        intake_id: id,
        assessment_id: assessmentDetails?.id || subId,
        type: "assigned",
      }
      if (assessmentTypeSelected == 8) {
        getSupplementaryStdList(data).then(res => {
          setAssignedStudentList(res.data.list)
          setCourseResultAssignedList(res.data.course_result)
          setStatusAssignedList(res.data.status)
          setAssignloading(false)
        }
        ).catch(err => {
          setAssignloading(false)
          console.error("error", err)
        })
      } else if (assessmentTypeSelected == 9) {
        getSickAssessmentStudentList(data).then(res => {
          const assignedStudents = res.data.list || [];
          initialSickStudentIdsRef.current = assignedStudents.map(assignedStudent => assignedStudent.student_id);
          setAssignedStudentList(
            assignedStudents.map(assignedStudent => ({
              ...assignedStudent,
              isAssigned: true,
            }))
          );
          setCourseResultAssignedList(res.data.course_result || []);
          setStatusAssignedList(res.data.status || []);
          setAssignloading(false);
        }
        ).catch(err => {
          setAssignloading(false)
          console.error("error", err)
        })
      }
    }
  }, [refresh, assessmentTypeSelected, type, assessmentDetails?.id]);

  const overrideAssessColumns = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      sortFunction: sortingName,
      cell: (row) => {
        return (
          <span
            title={row.name}
            className="overflow-ellipsis2 ">
            {row.name ?
              <Link className="as-text-blue curser feature-name"
                target="_blank"
                to={row.Assmenttype == "no" ? `/courseAdministration/coursesdetails/${id}/${tab}/open/assigned/Details/${row.id}` : `/courseAdministration/assessment/quizzes/open/details/${row.smart_assignment_id}`}
              >
                <span className="textLimit100">{row.name}</span>
              </Link> :
              "-"}
          </span>
        )
      }
    },
    {
      name: "Assessment Type",
      selector: "type",
      sortable: true,
      cell: (row) => (
        row.type ? RenderAssessmentType(row.type).html : "-"
      )
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      cell: (row) => row.status ? RenderAssessmentStatus(row.status).html : "-",
    },
    {
      name: "Due Date",
      selector: "close_date_time_mili",
      sortable: true,
      cell: (row) => (
        row.close_date_time_mili ?
          <>
            <p className="right-space">{moment.unix(row.close_date_time_mili).format(TABLE_DATE_FORMAT)}</p>
            <p>{moment.unix(row.close_date_time_mili).format(TABLE_TIME_FORMAT)}</p>
          </>
          : "-"
      )
    },
    {
      name: "Actions",
      selector: "Action",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons d-flex">
            <Link
              title="Open"
              className="btn btn-primary rounded-circle"
              target="_blank"
              to={row.Assmenttype == "no" ? `/courseAdministration/coursesdetails/${id}/${tab}/open/assigned/Details/${row.id}` : `/courseAdministration/assessment/quizzes/open/details/${row.smart_assignment_id}`}
            >
              <i className="fal fa-folder-open"></i>
            </Link>
            {row.id == formik.values.override_mark_ass_id ? <button
              title="Remove"
              type="button"
              className="btn btn-danger rounded-circle"
              onClick={() => {
                formik.setFieldValue("override_mark_ass_id", "");
                formik.setFieldValue("override_mark_ass_type", "");
                formik.setFieldValue("maxGradeAchievable", "");
                setCheckedAllRows([]);
                setTempCheckedAllData([]);
                setLinkCourseData([]);
                setLinkCheckedAllRows([]);
              }}
            >
              <i className="fal fa-minus"></i>
            </button> :
              <button
                title="Add"
                type="button"
                className="btn btn-primary rounded-circle"
                onClick={() => {
                  formik.setFieldValue("override_mark_ass_id", row.id);
                  formik.setFieldValue("override_mark_ass_type", row.ass_type);
                  formik.setFieldValue("maxGradeAchievable", row.maximum_grade_achievable);
                  if (props.gradingStandard == 2) getOverrideGrademixList(row.id);
                  setOverRideId(row.id);
                  const overrideLinks = row?.spAssessmentLinks || [];
                  setLinkCourseData(overrideLinks);
                  setLinkCheckedAllRows(overrideLinks.map((overrideLink) => overrideLink.id));
                  const letterGradedOverrideLink = overrideLinks.find(
                    (overrideLink) => Number(overrideLink.grading_type) === 2
                  );
                  if (letterGradedOverrideLink) {
                    setCheckLetterTemplateCourse(true);
                  }
                }}
              >
                <i className="fal fa-plus"></i>
              </button>}
          </div>
        </div>
      ),
    }
  ])

  const studentColumns = useMemo(() => [
    {
      name: "Student",
      selector: "full_name",
      sortable: true,
      sortFunction: sortingStudentName,
      cell: (row) => (
        <div className="assigned-title-block-new">
          <div className="assigned-title-itm">
            <span className={"assigned-title-blk  name-icon cat-dark-red "}>
              {row?.photo ? (
                <img
                  src={`${IMAGE_URL}/${row?.photo
                    .replaceAll("/home/myaie/public_html/", "")
                    .replace("public/", "")}`}
                  alt="AIE"
                />
              ) : (
                InitialRender([
                  row.first_name,
                  row.last_name,
                ])
              )}
              <span
                className={`profile-box-2-status ${row.activity_status
                  ? row.activity_status.toLowerCase() == "online"
                    ? "Online"
                    : row.activity_status.toLowerCase() == "away"
                      ? "Away"
                      : "Offline"
                  : "Offline"
                  }`}
              >
                <i className="fas fa-circle"></i>
              </span>
              <Hover
                firstName={row.first_name}
                lastName={row.last_name}
                photo={row.photo}
                email={row.email}
                mobile={row.mobile}
                right={true}
                status={row.status}
                activity_status={row.activity_status}
                showNumber={true}
                number={row.student_crm_id}
              />
            </span>
            <Link
              to={`/studentAdministration/students/open/${row.student_id}/general`}
              target="_blank"
              className="as-text-blue curser feature-name width-155"
            >
              <span className="textLimit100">{row.full_name}</span>
            </Link>
          </div>
        </div>
      ),
    },
    {
      name: "Student No.",
      selector: "student_crm_id",
      sortFunction: stdNoSort,
      sortable: true,
      cell: (row) =>
        row.student_crm_id ? (
          <span className="feature-name">
            <span className="textLimit100">{row.student_crm_id}</span>
          </span>
        ) : (
          "-"
        ),
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      cell: (row) => row.status ? RenderStudentStatus(row.status).html : "-",
    },
    {
      name: "Course Grade",
      selector: "course_grade",
      sortable: true,
      cell: (row) => row.course_grade ? row.course_grade : "-",
    },
    {
      name: "Course Result",
      selector: "pass_status",
      sortable: true,
      cell: (row) => row.pass_status ? RenderQuizAttemptResultStatus(row.pass_status).html : "-",
    },
    {
      name: "Actions",
      selector: "Action",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons d-flex">
            <Link
              title="Open"
              className="btn btn-primary rounded-circle"
              to={`/studentAdministration/students/open/${row.student_id}/general`}
              target="_blank"
            >
              <i className="fal fa-folder-open"></i>
            </Link>
            {assessmentTypeSelected == 8 ? row.isAssigned ? <button
              title="Remove"
              type="button"
              className="btn btn-danger rounded-circle"
              onClick={() => handleRemoveStd(row)}
            >
              <i className="fal fa-user-minus"></i>
            </button> :
              <button
                title="Add"
                type="button"
                className="btn btn-primary rounded-circle"
                onClick={() => handleAddStd(row)}
              >
                <i className="fal fa-user-plus"></i>
              </button> : assessmentTypeSelected == 9 ? row.isAssigned ? <PermissionsGate scopes={["castsicktestremove"]} errorProps={{ disabled: true }}>
                <button
                  title="Remove"
                  type="button"
                  className="btn btn-danger rounded-circle"
                  onClick={() => handleRemoveStd(row)}
                >
                  <i className="fal fa-user-minus"></i>
                </button>
              </PermissionsGate> :
                <button
                  title="Add"
                  type="button"
                  className="btn btn-primary rounded-circle"
                  data-toggle="modal"
                  data-target="#assignStudent"
                  onClick={() => setSelectedStudentId(row.student_id)}
                >
                  <i className="fal fa-user-plus"></i>
                </button> : ""}
          </div>
        </div>
      ),
    },
  ]);


  const handleGetCourseDetails = () => {
    GetIntakeDetails(id)
      .then(res => {
        if (res.status == 200) {
          setIntakeDetails(res.data.data)
        }
      })
      .catch(err => {
        console.error("error >>>>>> ", err)
      })
  }

  useEffect(() => {
    handleGetCourseDetails()
  }, [])

  const getOverrideGrademixList = (id) => {
    getAssignedGrademixViaAssessment({ assessment_id: id })
      .then((response) => {
        const data = {
          exportStatus: true,
        };
        GradeLetterTemplateList(data)
          .then((res) => {
            let ls = [...checkedAllRows];
            let newData = response?.data?.getGradeMix.map(
              (gradeMix, index) => {
                ls.push(Number(gradeMix?.grade_id));
                let templateGrdaeMixPassMarkArr = [];
                let tempMixObj = res.data.list_data?.find(
                  (item) => item.id === gradeMix?.grading_template_id
                );
                let templateGrdaeMixArray =
                  tempMixObj?.gradeOptions?.length &&
                  tempMixObj?.gradeOptions.map((item) => {
                    templateGrdaeMixPassMarkArr.push({
                      value: item?.id,
                      label: item?.text,
                    });
                  });
                return {
                  ...gradeMix,
                  selectedTemplate: tempMixObj ? tempMixObj : {},
                  templateOptions: templateGrdaeMixPassMarkArr,
                };
              }
            );
            setCheckedAllRows([...ls]);
            setTempCheckedAllData([...newData]);
          })
          .catch((err) => {
            console.error(err);
          });
      }).catch((err) => {
        console.error(err, "error")
      })
  }

  useEffect(() => {
    if (props.lmType === "selfplaced") {
      formik.setFieldValue("allowAppeal", false);
    }
    setDataLoading(true)
    GetAssessmentsData(id, subId)
      .then((res) => {
        let x = {
          value: "",
          label: "",
        };
        x = res?.data?.assessment_moderator_marker.map((data) => {
          return { ...x, value: `${data.UserID}`, label: `${data.name}` };
        });
        setModeratorAndMarker(x);
        let tempAssessmentTypeArr = [];
        const assArr = res?.data?.assessment_type;
        Object.keys(assArr).map((key, index) => {
          tempAssessmentTypeArr.push({
            value: key,
            label: assArr[key],
            key: key,
          });
        });
        setAssessmentType(tempAssessmentTypeArr);
        //setting Grade
        let tempGradeArr = [
          {
            value: "2",
            label: "Letter",
            key: 2,
          },
          {
            value: "3",
            label: "Value",
            key: 3,
          },
          {
            value: "4",
            label: "No Grade",
            key: 4,
          },
        ];
        const gradeArr = res?.data?.grade;
        Object.keys(gradeArr).map((key, index) => {
          tempGradeArr.push({ value: key, label: gradeArr[key], key: key });
        });
        setGradeType(tempGradeArr);
        setGradeMixGradeType(tempGradeArr);
        setDataLoading(false);
        setApiDataLoaded(true);
      })
      .catch((error) => {
        setDataLoading(false);
        setApiDataLoaded(true);
        console.error("error: ", error);
      });
    if (type != "add" && id) {
      setAssignLoading(true)
      FetchAssessmentDetails(subId, id)
        .then((response) => {
          const tempAssessmentDetails = response?.data;
          setAssessmentDetails(response?.data);
          setOverRideId(response.data.override_mark_ass_id)
          formik.setFieldValue("isHybrid", response.data.isHybrid);
          setEditorState(response?.data?.details);
          dispatch(setAssessmentName(response.data.name));
          setTempCheckedAllData(response.data.getGradeMix);

          setAssessmentFile(response.data?.path);
          setAssessmentFileName(response.data?.path);
          setMemoFile(response.data?.path_marking);
          setMemofileName(response.data?.path_marking);
          setGradeSelected(tempAssessmentDetails?.grading_type);
          setModeratorSelected(
            tempAssessmentDetails && tempAssessmentDetails.assessment_moderator
              ? tempAssessmentDetails.assessment_moderator
              : []
          );
          const assessmentLinks = response?.data?.spAssessmentLinks || [];
          setLinkCourseData(assessmentLinks);
          setLinkCheckedAllRows(assessmentLinks.map((assessmentLink) => assessmentLink.id));
          const hasLetterGradedLink = assessmentLinks.some(
            (assessmentLink) => Number(assessmentLink.grading_type) === 2
          );
          if (hasLetterGradedLink) {
            setCheckLetterTemplateCourse(true);
          }
          setassessmentTypeSelected(response?.data?.ass_type);
          response?.data.assessment_marker_multiple &&
            setSelectedDomain(
              response?.data.assessment_marker_multiple?.length > 0 ? response?.data.assessment_marker_multiple?.split(",") : []
            );
          quizFormik.setFieldValue("quiz_id", response.data?.quiz_id);
          formik.setFieldValue("allowAppeal", response.data?.allowAppeal ? true : false);
          if (response.data?.quiz_id) {
            formik.setFieldValue("quiz_id", true);
            setQuizTotal(response?.data?.ass_total_mark);
          }
          let check = CheckJSONString(response?.data?.details);
          if (check) {
            const blocksFromHTML2 = convertFromRaw(
              JSON.parse(response?.data?.details)
            );
            let dataDescr = EditorState.createWithContent(blocksFromHTML2);
            const detail = draftToHtml(
              convertToRaw(dataDescr.getCurrentContent())
            );
            setEditorState(detail ? detail : "<p><p/>");
            setApiDataLoaded(true);
          } else {
            setEditorState(response?.data?.details);
            setApiDataLoaded(true);
          }

          formik.setFieldValue(
            "maximum_attempts",
            response?.data?.maximum_attempts == 0
              ? "0"
              : response?.data?.maximum_attempts
          );

          if (tempAssessmentDetails?.grading_type == 2 && !hasFetchedRef.current) {
            GetLetterTemplateOption()
              .then(async (res) => {
                let matchedLetterTemplate = res?.data.list_data?.find(
                  (item) => String(item.id) === String(response.data.grading_template_id)
                );
                setSelectedTemplate(matchedLetterTemplate);
                let ls = [...checkedAllRows];
                let newData = response?.data?.getGradeMix?.map(
                  (gradeMix, index) => {
                    ls.push(Number(gradeMix?.grade_id));
                    let templateGrdaeMixPassMarkArr = [];
                    let tempMixObj = res.data.list_data?.find(
                      (item) => item.id === gradeMix?.grading_template_id
                    );
                    let templateGrdaeMixArray =
                      tempMixObj?.gradeOptions?.length &&
                      tempMixObj?.gradeOptions.map((item) => {
                        templateGrdaeMixPassMarkArr.push({
                          value: item?.id,
                          label: item?.text,
                        });
                      });
                    return {
                      ...gradeMix,
                      selectedTemplate: tempMixObj ? tempMixObj : {},
                      templateOptions: templateGrdaeMixPassMarkArr,
                    };
                  }
                );
                await setTempCheckedAllData([...newData]);
                await setCheckedAllRows([...ls]);
                setAssignLoading(false)
                hasFetchedRef.current = true;
                setCheckLetterTemplateCourse(true)
              })
              .catch((err) => {
                console.error(err);
                setLoading(false);
                setAssignLoading(false)
              });
          } else {
            setCheckLetterTemplateCourse(true)
          }
        })
        .catch((error) => {
          console.error("error :", error);
        })
        .finally(() => {
          setAssignLoading(false)
        })
    } else {
      setApiDataLoaded(true);
    }
  }, [refresh]);

  useEffect(() => {
    if (checkLetterTemplateCourse && linkCourseData?.length > 0) {
      const needsTemplateOptions = linkCourseData.some(
        (data) => data.grading_type == 2 && !data.templateOptions?.length
      );

      if (needsTemplateOptions) {
        GetLetterTemplateOption()
          .then((res) => {
            const templateList = res?.data?.list_data ?? [];

            // Use functional update to avoid stale closure
            setLinkCourseData(prevData => {
              return prevData?.map((course) => {
                if (course.grading_type != 2) return course;

                const templateId = course.grading_template_id || course.selectedTemplate?.id;
                if (!templateId) return course;

                const matchedTemplate = templateList?.find(
                  (template) => String(template?.id) === String(templateId)
                );

                return {
                  ...course,
                  selectedTemplate: matchedTemplate || course.selectedTemplate || null,
                  templateOptions: matchedTemplate?.gradeOptions?.map((item) => ({
                    value: item.id,
                    label: item.text,
                  })) ?? [],
                };
              });
            });

            const isIndex = linkCourseData.findIndex((data) => data.grading_type == 2);
            setLetterTemplateCourse(true);
            setLettertemplateIndex(isIndex);
            setCheckLetterTemplateCourse(false);
          })
          .catch(() => {
            setCheckLetterTemplateCourse(false);
          });
      } else {
        setCheckLetterTemplateCourse(false);
      }
    }
  }, [checkLetterTemplateCourse, linkCourseData]);

  useEffect(() => {
    let shouldUpdate = false;

    const updatedData = linkCourseData?.map((item) => {
      if (item.grading_type === 4) {
        // Only update if fields are missing or incorrect
        const needsUpdate =
          item.assessment_total !== 0 ||
          item.pass_mark !== 0 ||
          item.exclude_from_calculation !== true;

        if (needsUpdate) {
          shouldUpdate = true;
          return {
            ...item,
            assessment_total: 0,
            pass_mark: 0,
            exclude_from_calculation: true,
          };
        }
      }
      return item;
    });

    if (shouldUpdate) {
      setLinkCourseData(updatedData);
    }
  }, [linkCourseData]);

  useEffect(() => {
    const getIntakesIds = (intakeArray) => {
      let intakes = [Number(id)];
      intakeArray.forEach((intakeData) => {
        if (intakeData.intake && intakeData.isDelete !== 1) {
          intakes.push(intakeData.intake);
        }
      });
      return [...new Set(intakes)];
    };

    const getLockedProgramme = async () => {
      try {
        const intakeIds = getIntakesIds(linkCourseData);
        const intakeIdsString = intakeIds.sort((a, b) => a - b).join(',');

        if (prevIntakeIdsRef.current !== intakeIdsString) {
          prevIntakeIdsRef.current = intakeIdsString;

          setIsDisabled(true);
          const payload = { intake_id: intakeIds };
          const { data: lockedProgrammeResult } = await lockedProgrammes(payload);
          if (lockedProgrammeResult.success) {
            setIsDisabled(false);
            setLinkedProgrammes(lockedProgrammeResult);
          }
        }
      } catch (error) {
        console.log(error);
        setIsDisabled(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.message || "Something went wrong",
        });
      }
    };

    if (assessmentDetails?.intake || type === "add") {
      getLockedProgramme();
    }

  }, [linkCourseData, id]);

  const getTimeMinutes = (data) => {
    if (`${data}`.length < 2) {
      return "0" + data;
    } else {
      return `${data}`;
    }
  };

  const quizFormik = useFormik({
    initialValues: {
      quiz_id: "",
    },
    validationSchema: Yup.object({
      quiz_id: Yup.string().required("Quiz is required"),
    }),
    onSubmit: (values, { resetForm }) => {
      $("#quiz").modal("hide");
      GetQuestionsByQuiz(values.quiz_id)
        .then((res) => {
          setQuizTotal(res.data.totalQuizScore);
          let arr = tempCheckedAllData.map(item => {
            return {
              ...item,
              assessment_total: res.data.totalQuizScore
            }
          })
          setTempCheckedAllData([...arr])
          formik.setFieldValue(
            "AssessmentTotal",
            res.data.totalQuizScore.toString()
          );
          formik.setFieldValue(
            "isDuration",
            res.data.totalQuizScore.toString()
          );
          formik.setFieldValue(
            "TimeLimitHours",
            res.data.description.time_limit_hours != null &&
              res.data.description.time_limit_hours > 0
              ? res.data.description.time_limit_hours
              : res.data.description.time_limit_minutes > 0
                ? "00"
                : ""
          );
          formik.setFieldValue(
            "TimeLimitMinutes",
            res.data.description.time_limit_minutes != null &&
              res.data.description.time_limit_minutes > 0
              ? res.data.description.time_limit_minutes
              : res.data.description.time_limit_hours > 0
                ? "00"
                : ""
          );
          formik.setFieldValue("quiz_id", values.quiz_id);
          formik.setFieldValue(
            "maximum_attempts",
            res.data.description.maximum_attempts
          );
          formik.setFieldValue("isHybrid", res.data.description.isHybrid);

        })
        .catch((err) => {
          console.error(err);
        });
    },
  });

  useEffect(() => {
    if (formik.values.quizCheck && quizFormik.values.quiz_id != "") {
      GetQuiz({ getPaginate: "true", quizId: quizFormik.values.quiz_id }).then(
        (res) => {
          if (Array.isArray(res?.data) && res?.data.length) {
            res.data.map((val) => {
              if (val.quid == quizFormik.values.quiz_id) {
                formik.setFieldValue("quiz_id", true);
                setIsDurationDisabled(true);
                setQuizLabel(val.quiz_name.trim());
              }
            });
          }
        }
      );
    }
  }, [quizFormik.values.quiz_id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      AssessmentName:
        assessmentDetails && assessmentDetails?.name
          ? assessmentDetails?.name
          : "",
      AssessmentType: assessmentDetails
        ? assessmentDetails?.ass_type == 0
          ? "0"
          : assessmentDetails?.ass_type
        : "",
      AssessmentTotal: assessmentDetails
        ? assessmentDetails.ass_total_mark == 0
          ? "0"
          : assessmentDetails?.ass_total_mark
        : "",
      Weight:
        assessmentDetails && assessmentDetails?.ass_weighting >= 0
          ? assessmentDetails?.ass_weighting
          : "",
      Code:
        assessmentDetails && assessmentDetails?.code
          ? assessmentDetails?.code
          : "",
      GradeType: assessmentDetails && assessmentDetails?.grading_type,
      Marker:
        assessmentDetails && assessmentDetails?.assessment_marker
          ? assessmentDetails?.assessment_marker_multiple
            ? (
              assessmentDetails?.assessment_marker +
              "," +
              assessmentDetails?.assessment_marker_multiple
            ).split(",")
            : [assessmentDetails?.assessment_marker]
          : [],
      Moderator:
        assessmentDetails && assessmentDetails?.assessment_moderator
          ? assessmentDetails?.assessment_moderator
          : "",
      Moderated:
        assessmentDetails && assessmentDetails?.notify_moderator
          ? assessmentDetails?.notify_moderator
          : "0",
      AssessmentFile:
        assessmentDetails && assessmentDetails?.path
          ? assessmentDetails?.path
          : "",
      MemoFile:
        assessmentDetails && assessmentDetails?.path_marking
          ? assessmentDetails?.path_marking
          : "",
      TimeLimitHours:
        assessmentDetails.timeHour > 0 && assessmentDetails.timeHour != null
          ? `${assessmentDetails?.timeHour}`.length
            ? getTimeMinutes(assessmentDetails?.timeHour)
            : ""
          : assessmentDetails?.timeMin > 0
            ? "00"
            : "",
      TimeLimitMinutes:
        assessmentDetails?.timeMin > 0 && assessmentDetails?.timeMin != null
          ? `${assessmentDetails?.timeMin}`.length
            ? getTimeMinutes(assessmentDetails?.timeMin)
            : ""
          : assessmentDetails.timeHour > 0
            ? "00"
            : "",
      Identification:
        assessmentDetails && assessmentDetails?.identification ? true : false,
      Camera:
        assessmentDetails && assessmentDetails?.camera
          ? assessmentDetails?.camera
          : "",
      ScreenShare:
        assessmentDetails && assessmentDetails?.screen_share
          ? assessmentDetails?.screen_share
          : "",
      Audio:
        assessmentDetails && assessmentDetails?.audio
          ? assessmentDetails?.audio
          : "",
      openDateAndTime:
        assessmentDetails &&
          assessmentDetails.openDateAndTime &&
          assessmentDetails.openDateAndTime !== "NaN"
          ? new Date(parseInt(assessmentDetails.openDateAndTime))
          : "",
      closeDateAndTime:
        assessmentDetails &&
          assessmentDetails.closeDateAndTime &&
          assessmentDetails.closeDateAndTime !== "NaN"
          ? new Date(parseInt(assessmentDetails.closeDateAndTime))
          : "",
      deadlineDateAndTime:
        assessmentDetails &&
          assessmentDetails.deadlineDateAndTime &&
          assessmentDetails.deadlineDateAndTime !== "NaN"
          ? new Date(parseInt(assessmentDetails.deadlineDateAndTime))
          : "",
      appealCloseDate:
        assessmentDetails &&
          assessmentDetails.appealCloseDate &&
          assessmentDetails.appealCloseDate !== "NaN"
          ? new Date(parseInt(assessmentDetails.appealCloseDate))
          : "",
      appealOpenDate:
        assessmentDetails &&
          assessmentDetails.appealOpenDate &&
          assessmentDetails.appealOpenDate !== "NaN"
          ? new Date(parseInt(assessmentDetails.appealOpenDate))
          : "",
      allowAppeal:
        assessmentDetails && assessmentDetails.allowAppeal == 1 ? true : false,
      isDuration:
        assessmentDetails && assessmentDetails.timeLimitActive ? true : false,
      multiplicator:
        assessmentDetails && assessmentDetails?.multiplicator
          ? assessmentDetails?.multiplicator
          : "",
      offset:
        assessmentDetails && assessmentDetails?.offset
          ? assessmentDetails?.offset
          : "",
      passMark:
        assessmentDetails && assessmentDetails?.pass_mark
          ? assessmentDetails?.pass_mark
          : "",
      details: "",
      quiz_id: "",
      maximum_attempts: assessmentDetails && assessmentDetails?.maximum_attempts ? assessmentDetails?.maximum_attempts : "",
      quizCheck: assessmentDetails && assessmentDetails.quiz_id
        ? true
        : false,
      isHybrid: assessmentDetails && assessmentDetails?.isHybrid ? assessmentDetails?.isHybrid : false,
      gradeMix: [],
      grading_standard: props?.gradingStandard ? props?.gradingStandard : 4,
      maxGradeAchievable: assessmentDetails && assessmentDetails?.maximum_grade_achievable ? assessmentDetails?.maximum_grade_achievable : 50,
      override_mark_ass_id: type == "duplicate" ? "" : assessmentDetails && assessmentDetails?.override_mark_ass_id ? assessmentDetails?.override_mark_ass_id : "",
      override_mark_ass_type: "",
      aggregation_method_id: intakeDetails?.aggregation_method_id,
      shareWith: assessmentDetails && assessmentDetails?.share_with ? assessmentDetails?.share_with : [],
      isDownloadAllowed: assessmentDetails && assessmentDetails?.is_download_allowed == 1 ? true : false,
      is_student_signature_required: assessmentDetails && assessmentDetails?.is_student_signature_required == 1 ? 1 : 0,
      is_marker_signature_required: assessmentDetails && assessmentDetails?.is_marker_signature_required == 1 ? 1 : 0,
      pass_required: assessmentDetails && assessmentDetails.pass_required == 1 ? 1 : 0,
      exclude_from_calculation: assessmentDetails && assessmentDetails.exclude_from_calculation == 1 ? 1 : 0,
      linkAssessmentCourse: [],
      path_size: assessmentDetails?.path_size,
      assessmentType: "document",
      studentSignature: false,
      lecturerSignature: false,
      isEmbeddedPdf: false,
    },
    validate: (values) => {
      const errors = {};

      // Time limit validation - runs on every change
      if ((values.quizCheck || values.isDuration) &&
        values.openDateAndTime &&
        values.closeDateAndTime &&
        values.TimeLimitHours &&
        values.TimeLimitMinutes) {

        const totalMinutes = Number(values.TimeLimitHours) * 60 + Number(values.TimeLimitMinutes);
        const availableMinutes = moment(values.closeDateAndTime).diff(
          moment(values.openDateAndTime),
          "minutes"
        );

        if (totalMinutes > availableMinutes) {
          errors.TimeLimitHours = "Time limit exceeds available assessment duration";
        }
      }

      return errors;
    },
    validationSchema: Yup.object({
      AssessmentName: Yup.string()
        .required("Assessment Name is required")
        .trim(),
      Code: Yup.string()
        .required("Code is required")
        .trim(),
      AssessmentType: Yup.string()
        .required("Assessment Type is required")
        .test(
          "no-courses-allowed-for-supplementary",
          "No courses can be linked for Supplementary assessment type.",
          (value) => {
            // Only care about Supplementary / Sick (8)
            if (String(value) !== "8") return true;

            // courses that are NOT deleted
            const activeCourses = linkCourseData.filter(
              course => course.isDelete !== 1
            );

            // valid if no active courses
            return activeCourses.length === 0;
          }
        ),
      quiz_id: Yup.string().when("quizCheck", {
        is: true,
        then: Yup.string().required("Quiz is required"),
      }),
      AssessmentTotal: Yup.mixed().when(["grading_standard", "GradeType"], {
        is: (grading_standard, GradeType) =>
          Number(grading_standard) === 2 || Number(GradeType) === 4,
        then: Yup.mixed().notRequired(),
        otherwise: Yup.number()
          .typeError("Assessment Total must be a number")
          .required("Assessment Total is required")
          .min(1, "Assessment Total must be greater than 0"),
      }),
      GradeType: Yup.string().when("grading_standard", {
        is: 2,
        then: Yup.string().notRequired(),
        otherwise: Yup.string().required("Grade Type is required"),
      }),
      openDateAndTime: Yup.string().when("isRequired", {
        is: () => props.lmType !== "selfplaced",
        then: Yup.string().required("Open Date & Time is required"),
      }),
      closeDateAndTime: Yup.string().when("isRequired", {
        is: () => props.lmType !== "selfplaced",
        then: Yup.string()
          .required("Close Date & Time is required")
          .test(
            "is-greater",
            "Close Date & Time should be greater than open date time",
            function (value) {
              const { openDateAndTime } = this.parent;
              return moment(value).isSameOrAfter(moment(openDateAndTime));
            }
          ),
      }),
      maximum_attempts: Yup.string().when("quizCheck", {
        is: true,
        then: Yup.string().required("Maximum Attempts should be at least 1"),
      }),
      passMark: Yup.number().when(["grading_standard", "GradeType"], {
        is: (grading_standard, GradeType) => grading_standard == 2 || GradeType == 4,
        then: Yup.number().nullable(),
        otherwise: Yup.number().when(["AssessmentType", "maxGradeAchievable"], {
          is: (ass_type, maxGrade) => ass_type == 8 || overrideMarkFor > 0,
          then: Yup.number()
            .required("Pass mark is required")
            .max(Yup.ref("maxGradeAchievable"), "Pass mark cannot be more than Maximum Grade Achievable"),
          otherwise: Yup.number().when(["GradeType", "AssessmentTotal"], {
            is: (grade, assessmentTotal) => grade == 0 && assessmentTotal,
            then: Yup.number()
              .required("Pass mark is required")
              .max(100, "Pass mark cannot be more than 100%"),
            otherwise: Yup.number().when(["GradeType", "AssessmentTotal"], {
              is: (grade, assessmentTotal) => grade == 3 && assessmentTotal,
              then: Yup.number()
                .required("Pass mark is required")
                .max(Yup.ref("AssessmentTotal"), "Pass mark cannot be more than Assessment Total"),
              otherwise: Yup.number().required("Pass mark is required"),
            })
          })
        }),
      }),
      gradeMix: Yup.mixed().test(
        "required",
        "Please Assign at least One Grade Mix",
        (value) => {
          if (!tempCheckedAllData?.length && props.gradingStandard == 2) {
            return false;
          } else {
            let isValid = true;
            let errorArr = [];

            tempCheckedAllData.forEach((item) => {
              let errorObj = {
                field_name: [],
                errorMessage: [],
              };

              if (
                item.grading_type != 0 &&
                item.grading_type != 1 &&
                item.grading_type != 2 &&
                item.grading_type != 3
              ) {
                errorObj[`field_name`].push("Grade Type");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Grade Type is required`
                );
                isValid = false;
              }

              if (
                !item.assessment_total ||
                item.assessment_total == "" ||
                item.assessment_total == undefined ||
                item.assessment_total == null
              ) {
                errorObj[`field_name`].push("Assessment Total");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Assessment Total is required`
                );
                isValid = false;
              }

              if (
                item?.aggregation_method_id == 6 && (!item.ass_weighting ||
                  item.ass_weighting == "" ||
                  item.ass_weighting == undefined ||
                  item.ass_weighting == null)
              ) {
                errorObj[`field_name`].push("Weight");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Weight is required`
                );
                isValid = false;
              }

              if (
                item.assessment_total <= 0
              ) {
                errorObj[`field_name`].push("Assessment Total");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Assessment Total Cannot be Negative or 0`
                );
                isValid = false;
              }

              if (
                item.pass_mark === "" ||
                item.pass_mark == undefined ||
                item.pass_mark == null
              ) {
                errorObj[`field_name`].push("Pass Mark");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Pass Mark is required`
                );
                isValid = false;
              }

              if (
                (item.grading_type == 3) && item.assessment_total && item.pass_mark && +item.pass_mark >= +item.assessment_total
              ) {
                errorObj[`field_name`].push("Pass Mark");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Pass Mark cannot be more than Assessment Total`
                );
                isValid = false;
              }

              if (
                item.grading_type == 0 && 100 < +item.pass_mark
              ) {
                errorObj[`field_name`].push("Pass Mark");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Pass Mark cannot be more than 100%`
                );
                isValid = false;
              }

              if (Object.keys(errorObj.field_name).length) {
                errorArr.push(errorObj);
              } else {
                errorArr.push(false)
              }
            });
            setGradeMixError(errorArr);

            return isValid;
          }
        }
      ),
      linkAssessmentCourse: Yup.mixed().test(
        "course-validation",
        "Course validation failed",
        (value) => {
          if (props.gradingStandard == 2) {
            return true;
          } else {
            let isValid = true;
            let errorArr = [];

            linkCourseData.forEach((item, index) => {
              if (item.isDelete == 1) {
                errorArr.push(false);
                return;
              }

              let errorObj = {
                field_name: [],
                errorMessage: [],
              };

              if (
                item.grading_type != 0 &&
                item.grading_type != 1 &&
                item.grading_type != 2 &&
                item.grading_type != 3 &&
                item.grading_type != 4
              ) {
                errorObj.field_name.push("Grade Type");
                errorObj.errorMessage.push(`${item.name} Grade Type is required`);
                isValid = false;
              }

              if (item.grading_type != 4) {
                if (item.assessment_total === "" || item.assessment_total === undefined || item.assessment_total === null) {
                  errorObj.field_name.push("Assessment Total");
                  errorObj.errorMessage.push(`${item.name} Assessment Total is required`);
                  isValid = false;
                } else if (item.assessment_total <= 0) {
                  errorObj.field_name.push("Assessment Total");
                  errorObj.errorMessage.push(`${item.name} Assessment Total must be greater than 0`);
                  isValid = false;
                }
              }

              if (
                item?.aggregation_method_id == 6 &&
                (item.weight === "" || item.weight === undefined || item.weight === null) &&
                item.grading_type != 4
              ) {
                errorObj.field_name.push("Weight");
                errorObj.errorMessage.push(`${item.name} Weight is required`);
                isValid = false;
              }

              if (
                (item.pass_mark === "" ||
                  item.pass_mark === undefined ||
                  item.pass_mark === null) &&
                item.grading_type != 4
              ) {
                errorObj.field_name.push("Pass Mark");
                errorObj.errorMessage.push(`${item.name} Pass Mark is required`);
                isValid = false;
              }

              if (
                item.grading_type == 3 &&
                item.assessment_total !== undefined &&
                item.assessment_total !== null &&
                item.assessment_total !== "" &&
                item.pass_mark !== undefined &&
                item.pass_mark !== null &&
                item.pass_mark !== ""
              ) {
                const assessmentTotal = Number(item.assessment_total);
                const passMark = Number(item.pass_mark);

                if (passMark > assessmentTotal) {
                  errorObj.field_name.push("Pass Mark");
                  errorObj.errorMessage.push(
                    `${item.name} Pass Mark cannot be more than Assessment Total`
                  );
                  isValid = false;
                }

                if (passMark < 0) {
                  errorObj.field_name.push("Pass Mark");
                  errorObj.errorMessage.push(
                    `${item.name} Pass Mark cannot be negative`
                  );
                  isValid = false;
                }
              }

              if (
                item.grading_type == 0 &&
                item.pass_mark !== undefined &&
                item.pass_mark !== null &&
                item.pass_mark !== "" &&
                Number(item.pass_mark) > 100
              ) {
                errorObj.field_name.push("Pass Mark");
                errorObj.errorMessage.push(
                  `${item.name} Pass Mark cannot be more than 100%`
                );
                isValid = false;
              }

              if (errorObj.field_name.length > 0) {
                errorArr.push(errorObj);
              } else {
                errorArr.push(false);
              }
            });

            setCourseError(errorArr);
            return isValid;
          }
        }
      ),
      deadlineDateAndTime: Yup.string()
        .nullable()
        .when("isHybrid", {
          is: (isHybrid) =>
            (isHybrid == true || isHybrid == "true") &&
            props.lmType !== "selfplaced",
          then: Yup.string()
            .nullable()
            .required("Marking Deadline is required")
            .test(
              "is-greater",
              "Marking Date & Time should be greater than closing date time",
              function (value) {
                const { closeDateAndTime } = this.parent;
                return moment(value).isSameOrAfter(moment(closeDateAndTime));
              }
            ),
        }),

      TimeLimitHours: Yup.string().when(
        ["quizCheck", "isDuration", "openDateAndTime", "closeDateAndTime"],
        {
          is: (quizCheck, isDuration, openDateAndTime, closeDateAndTime) =>
            (quizCheck || isDuration) && openDateAndTime && closeDateAndTime,
          then: Yup.string()
            .required("Time Limit Hours is required")
            .test("duration-check", function (value) {
              const {
                TimeLimitMinutes,
                openDateAndTime,
                closeDateAndTime,
              } = this.parent;

              // Only validate when all values exist
              if (value && TimeLimitMinutes && openDateAndTime && closeDateAndTime) {
                const totalMinutes = Number(value) * 60 + Number(TimeLimitMinutes);
                const availableMinutes = moment(closeDateAndTime).diff(
                  moment(openDateAndTime),
                  "minutes"
                );

                if (totalMinutes > availableMinutes) {
                  return this.createError({
                    message: "Time limit exceeds available assessment duration",
                  });
                }
              }

              return true;
            }),
          otherwise: Yup.string().notRequired(),
        }
      ),
      TimeLimitMinutes: Yup.string().when(["quizCheck", "isDuration"], {
        is: (quizCheck, isDuration) => quizCheck == true || isDuration == true,
        then: Yup.string().required("Time Limit Minutes is required"),
      }),
      maxGradeAchievable: Yup.number().nullable().when(["AssessmentType", "GradeType"], {
        is: (ass_type, grade) => (ass_type == 8 || overrideMarkFor > 0) && grade == 0,
        then: Yup.number()
          .required("Maximum Grade Achievable is required")
          .max(100, "Maximum Grade Achievable cannot be more than 100%"),
        otherwise: Yup.number().when(["AssessmentType", "GradeType", "AssessmentTotal"], {
          is: (ass_type, grade, assessmentTotal) => (ass_type == 8 || overrideMarkFor > 0) && grade == 3 && assessmentTotal,
          then: Yup.number()
            .required("Maximum Grade Achievable is required")
            .max(Yup.ref("AssessmentTotal"), "Maximum Grade Achievable cannot be more than Assessment Total"),
        })
      }),
      override_mark_ass_id: Yup.string().when("AssessmentType", {
        is: "9",
        then: Yup.string().required("Please select a assessment to override mark for")
      }),
    }),
    onSubmit: async (values, { resetForm }) => {

      if (linkedProgrammes?.isLocked) {
        handleGradesLocked(linkedProgrammes.data, "assessment");
        return;
      }

      const gradeMix =
        tempCheckedAllData?.length &&
        tempCheckedAllData?.map((data) => ({
          id: data.grade_id ? data.grade_id : data.id,
          offset: parseInt(data?.offset) ? parseInt(data.offset) : "",
          grading_type: parseInt(data?.grading_type),
          multiplicator: parseInt(data?.multiplicator)
            ? parseInt(data.multiplicator)
            : "",
          pass_mark: parseInt(data?.pass_mark),
          grading_template_id: data?.selectedTemplate?.id,
          assessment_total: parseInt(data?.assessment_total),
          ass_weighting: parseInt(data?.ass_weighting)
        }));

      const mapLinkPayload = (data, forceDelete = false) => ({
        id: data.id || "",
        assessment_id: data.assessment_id || "",
        intake: data.intake ? data.intake : data.id || "",
        grading_type: data.grading_type || "",
        assessment_total: data.assessment_total || "",
        offset: data.offset || "",
        multiplicator: data.multiplicator || "",
        grading_template_id: data?.selectedTemplate?.id || 0,
        pass_mark: data.pass_mark >= 0 ? data.pass_mark : "",
        weight: data.weight || "",
        pass_required: data.pass_required || "",
        exclude_from_calculation: data.exclude_from_calculation || "",
        isDelete: forceDelete ? 1 : (data.isDelete ? 1 : 0),
        created_at: data.created_at || "",
        updated_at: data.updated_at || "",
        course: data.course || "",
        name: data.name || "",
      });

      const linkAssessmentCourse = linkCourseData?.map((data) => mapLinkPayload(data)) || [];

      const isOverrideChanged =
        type === "open" &&
        Number(values.AssessmentType) === 9 &&
        String(values.override_mark_ass_id ?? "") !==
        String(assessmentDetails?.override_mark_ass_id ?? "");

      const linkPayload = isOverrideChanged
        ? [
          ...(assessmentDetails?.spAssessmentLinks || []).map((data) => mapLinkPayload(data, true)),
          ...linkAssessmentCourse,
        ]
        : linkAssessmentCourse;
      if (
        (values.quizCheck === true || values.isDuration === true) &&
        values.TimeLimitHours == 0 &&
        values.TimeLimitMinutes == 0
      ) {
        formik.setFieldError(
          "TimeLimitHours",
          "Hours must be greater than zero."
        );
        formik.setFieldError(
          "TimeLimitMinutes",
          "Minutes must be greater than zero."
        );
        return;
      } else {
        setAssessmentLoad(true);
        setLoading(true);
        let formData = new FormData();
        type === "open" && formData.set("assessment_id", subId);
        formData.set("intake", id);
        formData.set("name", values?.AssessmentName?.trim());
        formData.set("due", 1);
        formData.set("code", values?.Code);
        formData.set(
          "open_date_time",
          !isNaN(Date.parse(values.openDateAndTime) / 1000)
            ? Date.parse(values.openDateAndTime) / 1000
            : ""
        );
        formData.set(
          "appeal_open_date",
          !isNaN(Date.parse(values.appealOpenDate) / 1000)
            ? Date.parse(values.appealOpenDate) / 1000
            : ""
        );
        formData.set(
          "appeal_close_date",
          !isNaN(Date.parse(values.appealCloseDate) / 1000)
            ? Date.parse(values.appealCloseDate) / 1000
            : ""
        );
        formData.set("allow_appeal", values.allowAppeal ? 1 : 0);
        if (values.allowAppeal === false) {
          formData.set("appeal_open_date", 0);
          formData.set("appeal_close_date", 0);
        }
        formData.set(
          "close_date_time",
          !isNaN(Date.parse(values.closeDateAndTime) / 1000)
            ? Date.parse(values.closeDateAndTime) / 1000
            : ""
        );
        formData.set(
          "marking_deadline_date",
          !isNaN(Date.parse(values.deadlineDateAndTime) / 1000)
            ? Date.parse(values.deadlineDateAndTime) / 1000
            : ""
        );
        formData.set("ass_total_mark", values?.AssessmentTotal);
        if (props?.gradingStandard != 2) {
          formData.set("grade", values.GradeType);
          formData.set("pass_mark", values.passMark);
          formData.set("grading_template_id", selectedTemplate?.id);
          formData.set("multiplicator", values.multiplicator);
          formData.set("offset", values.offset);
          formData.set("linkAssessmentCourse", JSON.stringify(linkPayload));
        }
        if (props?.gradingStandard == 2) {
          formData.set("gradeMix", JSON.stringify(gradeMix));
        }
        formData.set("ass_weighting", values?.Weight);
        formData.set(
          "ass_type",
          assessmentTypeSelected || formik.values.AssessmentType
        );

        formData.set("share_with", JSON.stringify(values.shareWith));
        formData.set("ass_marker_sent", 0);
        formData.set("ass_moderator_sent", 1);
        formData.set("timeHour", values?.TimeLimitHours);
        formData.set("timeMin", values?.TimeLimitMinutes);
        formData.set("audio", values?.Audio ? 1 : 0);
        formData.set("camera", values?.Camera ? 1 : 0);
        formData.set("identification", values?.Identification ? 1 : 0);
        formData.set("screen_share", values?.ScreenShare ? 1 : 0);
        // --- local Library multipart (before Phase 2 write cutover) ---
        // formData.append("path_marking", memoFile);
        formData.append("timeLimitActive", values.isDuration ? 1 : 0);
        formData.set("details", editorState);
        if (formik.values.quizCheck) {
          formData.append("quiz_id", quizFormik.values.quiz_id);
          formData.append("maximum_attempts", values.maximum_attempts);
          formData.append("is_student_signature_required", values.is_student_signature_required);
          formData.append("is_marker_signature_required", values.is_marker_signature_required);
        }

        if (!formik.values.quizCheck) {
          formData.append("path", values?.AssessmentFile || "");
          formData.append(
            "pathUploadedFrom",
            // 0 = local Library when the brief was cleared
            values?.AssessmentFile ? (assessmentDetails?.pathUploadedFrom || "0") : "0"
          );
        }
        formData.set("assessment_marker", [...new Set(values.Marker)]);
        formData.set("assessment_moderator", values?.Moderator);
        if (type == "open") {
          formData.append("notify_moderator", values.Moderated);
        }
        if (formik.values.AssessmentType == 8 || overrideMarkFor > 0) {
          formData.set("assigned_std", JSON.stringify(assignedStudentList.map(item => item.student_id)))
          formData.set("maximum_grade_achievable", values.maxGradeAchievable)
        }
        if (formik.values.AssessmentType == 9) {
          formData.set("override_mark_ass_id", values.override_mark_ass_id)
          newAssignee.map((item) => {
            item.files.map((file, ind) => {
              formData.set(`file_${item.student_id}[${ind}]`, file)
            })
            delete item.files
          })
          formData.set(`assigned_std_to_sick`, JSON.stringify(newAssignee));
          if (type === "open") {
            const removedStudentIds = initialSickStudentIdsRef.current.filter(
              (studentId) => !assignedStudentList.some((assignedStudent) => assignedStudent.student_id === studentId)
            );
            if (removedStudentIds.length) {
              formData.set("removeSickAssessmentStudentIds", JSON.stringify(removedStudentIds));
            }
          }
        }

        // New R2 brief already sent path_size above; keep existing size on edit of a non-File path
        if (!(type === "add") && !(values?.AssessmentFile instanceof File)) {
          formData.append("path_size", values?.path_size)
        }
        formData.set("is_download_allowed", values.isDownloadAllowed ? 1 : 0);
        formData.append("pass_required", values.pass_required)
        formData.append("exclude_from_calculation", values.exclude_from_calculation)

        // ~~ Add EmbeddedPDF information
        formData.append("isEmbeddedPdf", values.isEmbeddedPdf);

        AddAssessment(formData)
          .then((res) => {
            setLoading(false);
            if (type == "add") {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Added successfully",
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Updated successfully",
              });
            }

            // resetForm();
            // setImage(user);
            setAssessmentLoad(false)
            if (type == "add" || type == "duplicate") {
              history.push(`/courseAdministration/coursesdetails/${id}/assessments/show`);
            } else {
              setRefresh(!refresh)
              setHandleRefreshCourseList(Date.now())
            }
          })
          .catch((err) => {
            console.error("err :", err);
            setAssessmentLoad(false);
            setLoading(false);

            const rawMessage = err?.response?.data?.message || "";
            const updatedMessage = rawMessage.replace("intakes", "course");

            const isSupplementary = Number(formik.values.AssessmentType) === 8;

            const swalOptions = {
              icon: "error",
              title: isSupplementary
                ? "Failed to create supplementary exam"
                : "Error",
            };

            if (rawMessage) {
              const errors = err?.response?.data?.errors;

              let errorList = "";
              if (Array.isArray(errors) && errors.length > 0) {
                errorList = errors
                  .map((error) => `<li>${error?.name ?? ""}</li>`)
                  .join("");
              }

              swalOptions.html = `
                <div>${updatedMessage}</div>
                ${errorList ? `<br><ul style="text-align:left;">${errorList}</ul>` : ""}
              `;
            } else {
              swalOptions.text = err?.response?.data?.message || "Something went wrong";
            }

            Swal.fire(swalOptions);
          });
      }
    },
  });

  const embeddedPdfHasNoFields =
    formik.values.assessmentType === "embeddedPdf" &&
    embeddedPdfFieldCheckComplete &&
    embeddedPdfFieldCount === 0;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    formik.setFieldValue("grading_standard", props.gradingStandard)
  }, [props.gradingStandard])

  const handleSendInstruction = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("assessment_marker", selectedDomain);
    data.append("intake", id);
    data.append("marking_deadline_date", moment(formik.values.deadlineDateAndTime).format("YYYY-MM-DD HH:mm"));
    data.append("close_date_time", moment(formik.values.closeDateAndTime).format("YYYY-MM-DD HH:mm"));
    data.append("assignmentid", subId);
    data.append("sender", user?.UserID);
    SendAssessmentInstruction(data)
      .then((res) => {
        Swal.fire("Send!", "", "success");
      })
      .catch((error) => {

        Swal.fire("Error!", "", "error");
      });
  };

  const handleMemoDelete = () => {
    setMemoFile("");
    setMemofileName("");
    formik.setFieldValue("MemoFile", "");
  };

  const handleQuizDelete = () => {
    quizFormik.setFieldValue("quiz_id", "");
    setQuizLabel("");
    setIsDurationDisabled(false);
    formik.setFieldValue(
      "AssessmentTotal",
      assessmentDetails
        ? assessmentDetails.ass_total_mark == 0
          ? "0"
          : assessmentDetails?.ass_total_mark
        : ""
    );
    setTempCheckedAllData((prevData) => {
      const newData = prevData.map((item) => ({
        ...item,
        assessment_total: "",
      }));
      return newData;
    });
    formik.setFieldValue(
      "TimeLimitHours",
      assessmentDetails?.timeHour && `${assessmentDetails?.timeHour}`.length
        ? getTimeMinutes(assessmentDetails?.timeHour)
        : "00"
    );
    formik.setFieldValue(
      "TimeLimitMinutes",
      assessmentDetails?.timeMin && `${assessmentDetails?.timeMin}`.length
        ? getTimeMinutes(assessmentDetails?.timeMin)
        : "00"
    );
    // formik.resetForm();
    formik.setFieldValue(
      "isDuration",
      assessmentDetails && assessmentDetails.timeLimitActive ? true : false
    );
    formik.setFieldValue(
      "isAppeal",
      assessmentDetails && assessmentDetails.allowAppeal ? true : false
    );
    formik.setFieldValue(
      "isAppeal",
      assessmentDetails && assessmentDetails.allowAppeal ? true : false
    );
    formik.setFieldValue("quiz_id", "");
    quizFormik.resetForm();
  };

  const hourHandle = () => {
    let hourArr = [];
    for (let i = 0; i <= 23; i++) {
      hourArr.push({
        value: i.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        }),
        label:
          i.toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          }) + "h",
      });
    }
    return hourArr;
  };

  const MinutesHandle = () => {
    let minutesArray = [];

    for (let i = 0; i <= 59; i++) {
      minutesArray.push({
        value: i.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        }),
        label:
          i.toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          }) + "min",
      });
    }
    // ()=>{setMinuteArray(minutesArray)}
    return minutesArray;
  };

  const handleAssessment = () => {
    setAssessmentFile("");
    setAssessmentFileName("");
    formik.setFieldValue("AssessmentFile", "");
  };

  const sort_by = (field, reverse, primer) => {
    const key = primer
      ? function (x) {
        return primer(x[field]);
      }
      : function (x) {
        return x[field];
      };
    reverse = !reverse ? 1 : -1;
    return function (a, b) {
      return (a = key(a)), (b = key(b)), reverse * ((a > b) - (b > a));
    };
  };

  const addQuizzHandler = (qid, qlabel, quizData) => {
    quizFormik.setFieldValue("quiz_id", qid);
    formik.setFieldValue("quiz_id", qid);
    setQuizLabel(qlabel);
    setIsDurationDisabled(true);
    quizFormik.handleSubmit();
    $("#quiz").modal("hide");
  };
  const appealOlddate = new Date(formik.values.closeDateAndTime)
  const defaultAppealCloseDate = appealOlddate.setDate(appealOlddate.getDate() + 7)
  const handleRemoveStd = (row) => {
    let tempAssign = assignedStudentList
    let tempAvailable = availableStudentList;
    tempAssign.splice(tempAssign.indexOf(row), 1)
    if (assessmentTypeSelected == 9) {
      setNewAssignee(newAssignee.filter(assignee => assignee.student_id !== row.student_id))
      const existsInAvailable = tempAvailable.some(availableStudent => availableStudent.student_id === row.student_id)
      if (!existsInAvailable) {
        setAvailableStudentList([...tempAvailable, { ...row, isAssigned: false }])
      } else {
        setAvailableStudentList(tempAvailable.map(availableStudent => {
          if (availableStudent.student_id === row.student_id) {
            return { ...availableStudent, isAssigned: false }
          }
          return availableStudent
        }))
      }
    } else {
      const updatedAvailableStudentList = tempAvailable.map(availableStudent => {
        if (availableStudent.student_id === row.student_id) {
          return { ...availableStudent, isAssigned: false }
        }
        return availableStudent
      })
      setAvailableStudentList([...updatedAvailableStudentList])
    }
    setAssignedStudentList([...tempAssign])
  }

  const handleAddStd = (row) => {
    let tempAssign = assignedStudentList
    let tempAvailable = availableStudentList;
    tempAssign.push({ ...row, isAssigned: true })
    let ab = tempAvailable.map(item => {
      if (item.student_id == row.student_id) {
        return { ...item, isAssigned: true }
      }
      return item
    })
    setAssignedStudentList([...tempAssign])
    setAvailableStudentList([...ab])
  }

  const dataToRenderAvailableStd = () => {
    let updatedData = [];
    let allData = availableStudentList;
    if (availableSearch.length) {
      let tempStudent = allData.filter((item) => {
        let includes = item.full_name?.toLowerCase().toString().includes(availableSearch.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempStudentNo = allData.filter((item) => {
        let includes = item.student_crm_id?.toString().toLowerCase().includes(availableSearch.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let data = [...tempStudent, ...tempStudentNo];
      let unique = [...new Set(data)];
      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (statusAvailable.arr?.length) {
      let tempAction = updatedData;
      let tempResult = tempAction.filter((item) => {
        const startsWith = statusAvailable.arr?.find((post, index) => {
          if (post?.toString() === item?.status.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (courseResultAvailable.arr?.length) {
      let tempMonth = updatedData;
      let tempResult = tempMonth.filter((item) => {
        const startsWith = courseResultAvailable.arr.find((post, index) => {
          let courseResult = item.pass_status
          if (post.toString() === courseResult.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (availableSearch?.length || statusAvailable.arr?.length || courseResultAvailable.arr?.length) {
      return updatedData;
    } else {
      return availableStudentList;
    }
  };

  const dataToRenderAssignedStd = () => {
    let updatedData = [];
    let allData = assignedStudentList;
    if (searchAssigned.length) {
      let tempStudent = allData.filter((item) => {
        let includes = item.full_name?.toLowerCase().toString().includes(searchAssigned.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempStudentNo = allData.filter((item) => {
        let includes = item.student_crm_id?.toString().toLowerCase().includes(searchAssigned.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let data = [...tempStudent, ...tempStudentNo];
      let unique = [...new Set(data)];
      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (statusAssigned.arr?.length) {
      let tempAction = updatedData;
      let tempResult = tempAction.filter((item) => {
        const startsWith = statusAssigned.arr?.find((post, index) => {
          if (post?.toString() === item?.status.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (courseResultAssigned.arr?.length) {
      let tempMonth = updatedData;
      let tempResult = tempMonth.filter((item) => {
        const startsWith = courseResultAssigned.arr.find((post, index) => {
          let courseResult = item.pass_status
          if (post.toString() === courseResult.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (searchAssigned?.length || statusAssigned.arr?.length || courseResultAssigned.arr?.length) {
      return updatedData;
    } else {
      return assignedStudentList;
    }
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    let isMounted = true;

    if (formik.values.AssessmentType == 9) {
      if (overrideAssessList.length && formik.values.override_mark_ass_id != "") {
        const selectedAssessment = overrideAssessList.find(
          (item) => item.id == formik.values.override_mark_ass_id
        );

        if (!selectedAssessment) return;

        const isOverrideChanged =
          type === "open" &&
          String(formik.values.override_mark_ass_id ?? "") !==
          String(assessmentDetails?.override_mark_ass_id ?? "");

        const shouldApplyOverrideData =
          type == "add" || type == "duplicate" || isOverrideChanged;

        // Only update state if component is still mounted
        if (isMounted) {
          setOverrideSelected(selectedAssessment);
          setOverrideMarkFor(selectedAssessment.override_mark_for);

          if (shouldApplyOverrideData) {
            if (selectedAssessment.spAssessmentLinks?.length) {
              setLinkCourseData(selectedAssessment.spAssessmentLinks);
              setLinkCheckedAllRows(selectedAssessment.spAssessmentLinks.map((item) => item.id));
              setHandleRefreshCourseList(Date.now());
              const gradingType = selectedAssessment?.spAssessmentLinks?.find((item) => item.grading_type == 2);

              if (gradingType) {
                setSelectedCourse(selectedAssessment?.spAssessmentLinks?.find((item) => item.grading_type == 2)?.selectedTemplate || {});
                setLettertemplateIndex(selectedAssessment?.spAssessmentLinks?.findIndex((item) => item.grading_type == 2));
                setCheckLetterTemplateCourse(true);
              }
            } else {
              setLinkCourseData([]);
              setLinkCheckedAllRows([]);
            }

            formik.setValues({
              ...formik.values,
              AssessmentTotal: selectedAssessment.ass_total_mark,
              GradeType: selectedAssessment.grading_type,
              passMark: selectedAssessment.pass_mark,
              multiplicator: selectedAssessment.multiplicator,
              offset: selectedAssessment.offset,
              Weight: selectedAssessment.ass_weighting,
              pass_required: selectedAssessment.pass_required,
              exclude_from_calculation: selectedAssessment.exclude_from_calculation
            });
            setGradeSelected(selectedAssessment.grading_type);

            if (selectedAssessment.grading_type == 2) {
              setAssignLoading(true);
              GetLetterTemplateOption()
                .then((res) => {
                  if (!isMounted) return;
                  const letterTemplateList = res?.data?.list_data || [];
                  const matchedLetterTemplate = letterTemplateList.find(
                    (item) => String(item.id) === String(selectedAssessment?.grading_template_id)
                  );
                  setSelectedTemplate(matchedLetterTemplate || {});
                  setReload((prev) => !prev);
                  setLetterTemplateCourse(false);
                  setAssignLoading(false);
                })
                .catch((err) => {
                  console.error(err);
                  if (isMounted) {
                    setLoading(false);
                    setAssignLoading(false);
                  }
                });
            }
          }
        }
      } else {
        if ((type == "add" || type == "duplicate") && isMounted) {
          setOverrideSelected({});
          setOverrideMarkFor("");
          setCheckLetterTemplateCourse(false);
          setLinkCourseData([]);
          setLinkCheckedAllRows([]);
          setCourseError([]);

          // Batch reset all formik values at once for better performance
          formik.setValues({
            ...formik.values,
            AssessmentTotal: "",
            GradeType: "",
            passMark: "",
            multiplicator: "",
            offset: "",
            Weight: "",
            pass_required: "",
            exclude_from_calculation: ""
          });

          setGradeSelected("");
          setSelectedTemplate({});
          setLettertemplateIndex(null);
        }
      }
    }

    return () => {
      isMounted = false;
    };
  }, [formik.values.override_mark_ass_id, overrideAssessList, formik.values.AssessmentType])

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (gradeSelected) {
      formik.setFieldTouched("AssessmentTotal", true)
      formik.setFieldTouched("passMark", true)
      formik.setFieldTouched("Weight", true)
    }
  }, [gradeSelected]);


  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (formik.values.closeDateAndTime && !formik.values.appealOpenDate) {
      formik.setFieldValue("appealOpenDate", formik.values.closeDateAndTime);

      let appealCloseDate = new Date(formik.values.closeDateAndTime);
      appealCloseDate.setDate(appealCloseDate.getDate() + 7);
      formik.setFieldValue("appealCloseDate", appealCloseDate);
    }
  }, [formik.values.closeDateAndTime, formik.values.appealOpenDate]);

  const dataToRenderOverrideAssess = () => {
    let updatedData = [];
    let allData = overrideAssessList;
    if (overrideSearch.length) {
      let tempAssessment = allData.filter((item) => {
        let includes = item.name?.toLowerCase().toString().includes(overrideSearch.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let data = [...tempAssessment];
      let unique = [...new Set(data)];
      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (overrideStatus.arr?.length) {
      let tempStatus = updatedData;
      let tempResult = tempStatus.filter((item) => {
        const startsWith = overrideStatus.arr.find(function (post, index) {
          if (post.toString().toLowerCase() === item.status.toString().toLowerCase() ? item.status.toString().toLowerCase() : "") return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      })

      updatedData = tempResult;
    }

    if (overrideAssessType.arr.length) {
      let tempType = updatedData;
      let tempResult = tempType.filter((item) => {
        const startsWith = overrideAssessType.arr.find(function (post, index) {
          if (post.toString().toLowerCase() === item.type.toString().toLowerCase()) {
            return item;
          }
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempResult;
    }

    if (overrideSearch?.length || overrideStatus.arr?.length || overrideAssessType.arr?.length) {
      return updatedData;
    } else {
      return overrideAssessList
    }
  }


  const SelectedOverride = () => {
    return (
      <div className="d-flex select-delete">
        <Link
          className="as-text-blue curser"
          title={overrideSelected?.name}
          target="_blank"
          to={overrideSelected?.Assmenttype == "no" ? `/courseAdministration/coursesdetails/${id}/${tab}/open/assigned/Details/${overrideSelected?.id}` : `/courseAdministration/assessment/quizzes/open/details/${overrideSelected?.smart_assignment_id}`}
        >
          <span className="textLimit100">
            {TrimText(overrideSelected?.name, 20)}
          </span>
        </Link>
        <button
          className="btn btn-danger rounded-circle btn-dropdown-item"
          title="Delete"
          onClick={() => {
            formik.setFieldValue("override_mark_ass_id", "");
            formik.setFieldValue("override_mark_ass_type", "");
            formik.setFieldValue("maxGradeAchievable", "")
            setTempCheckedAllData([])
            setCheckedAllRows([])
          }}
          disabled={formik.values.AssessmentType == 9 && assignedStudentList.length && type === "open"}
        >
          <i className="fal fa-trash-alt"></i>
        </button>
      </div>
    )
  }

  const exportDataAvailableStd = () => {
    let data = dataToRenderAvailableStd();
    const header = ["Student", "Student No", "Status", "Course Grade", "Course Result"];

    data = data?.map((row) => {
      return ({
        ...row,
        "Student": row.full_name ? row.full_name : "-",
        "Student No": row.student_crm_id ? row.student_crm_id : "-",
        "Status": row.status ? RenderStudentStatus(row.status).text : "-",
        "Course Grade": row.course_grade ? row.course_grade : "-",
        "Course Result": row.pass_status ? RenderQuizAttemptResultStatus(row.pass_status).text : "-"
      })
    });
    const pdfData = data.map((row) => {
      return [row["Student"], row["Student No"], row["Status"], row["Course Grade"], row["Course Result"]];
    });
    return {
      header,
      data,
      pdfData,
      columnStyles: {}
    }
  };

  const exportDataAssignedStd = () => {
    let data = dataToRenderAssignedStd();
    const header = ["Student", "Student No", "Status", "Course Grade", "Course Result"];

    data = data?.map((row) => {
      return ({
        ...row,
        "Student": row.full_name ? row.full_name : "-",
        "Student No": row.student_crm_id ? row.student_crm_id : "-",
        "Status": row.status ? RenderStudentStatus(row.status).text : "-",
        "Course Grade": row.course_grade ? row.course_grade : "-",
        "Course Result": row.pass_status ? RenderQuizAttemptResultStatus(row.pass_status).text : "-"
      })
    });
    const pdfData = data.map((row) => {
      return [row["Student"], row["Student No"], row["Status"], row["Course Grade"], row["Course Result"]];
    });
    return {
      header,
      data,
      pdfData,
      columnStyles: {}
    }
  };

  const exportDataOverrideFor = () => {
    let data = dataToRenderOverrideAssess();
    const header = ["Name", "Assessment Type", "Status", "Due Date"];

    data = data?.map((row) => {
      return ({
        ...row,
        "Name": row.name ? row.name : "-",
        "Assessment Type": row.type ? RenderAssessmentType(row.type).text : "-",
        "Status": row.status ? RenderAssessmentStatus(row.status).text : "-",
        "Due Date": row.close_date_time_mili ? `${moment.unix(row.close_date_time_mili).format(TABLE_DATE_FORMAT)} ${moment.unix(row.close_date_time_mili).format(TABLE_TIME_FORMAT)}` : "-"
      })
    });
    const pdfData = data.map((row) => {
      return [row["Name"], row["Assessment Type"], row["Status"], row["Due Date"]];
    });
    return {
      header,
      data,
      pdfData,
      columnStyles: {}
    }
  };

  function handleRemoveFile(file) {
    const selectedFiles = [...selectedFileForAppeal].filter(item => item !== file)
    setSelectedFileForAppeal([...selectedFiles])
  }

  const closeFunction = () => {
    setAppealReason("Sick");
    setStudentMessage("");
    setSelectedFileForAppeal([]);
    setSelectedStudentId();
    $('#assignStudent').modal("hide");
  }

  const handleSaveAppeal = () => {
    if (!studentMessage) {
      setAppealError("Student message is required")
      return
    } else {
      setAppealError("")
    }
    const tempNewAssignee = [...newAssignee]
    tempNewAssignee.push({
      student_id: selectedStudentId,
      studentMessage,
      files: selectedFileForAppeal,
      reason: appealReason
    })
    setNewAssignee(tempNewAssignee)
    const tempAvailableStudent = [...availableStudentList]
    const selectedStudent = tempAvailableStudent.find(item => item.student_id === selectedStudentId)
    tempAvailableStudent.splice(tempAvailableStudent.indexOf(selectedStudent), 1)
    setAvailableStudentList(tempAvailableStudent)
    const tempAssignStd = [...assignedStudentList]
    tempAssignStd.push({ ...selectedStudent, isAssigned: true })
    setAssignedStudentList(tempAssignStd)
    closeFunction()
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (formik.values.AssessmentType == 9) {
      setOverrideLoading(true);
      const values = {
        intake_id: id,
        assessment_id: subId,
        duplicate: type == "duplicate"
      };
      getOverrideAssessments(values)
        .then((res) => {
          if (res.status === 200) {
            setOverrideAssessList(res.data.result);
            setOverrideStatusList(res.data.statusFilter);
            setOverrideAssessTypeList(res.data.assessmentTypeFilter);
          }
        })
        .catch(console.error)
        .finally(() => setOverrideLoading(false));
    }
  }, [formik.values.AssessmentType, refresh]);

  const detectPdfFields = async (file) => {
    try {
      const fileUrl = URL.createObjectURL(file);

      const loadingTask = pdfjsLib.getDocument(fileUrl);
      const pdf = await loadingTask.promise;

      const fieldNames = new Set();

      for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
        const page = await pdf.getPage(pageNumber);
        const annotations = await page.getAnnotations();
        annotations.forEach((annotation) => {
          if (annotation.subtype === "Widget" && annotation.fieldName) {
            fieldNames.add(annotation.fieldName);
          }
        });
      }

      const fieldCount = fieldNames.size;
      setEmbeddedPdfFieldCount(fieldCount);
      setEmbeddedPdfFieldCheckComplete(true);
      URL.revokeObjectURL(fileUrl);
    } catch (error) {
      console.error("Error detecting PDF fields:", error);

      setEmbeddedPdfFieldCount(0);
      setEmbeddedPdfFieldCheckComplete(true);
    }
  };
  return (
    <>
      <div className="card card-profile-info-card">
        <div className="">
          <div className="card-body-inr card-body-info">
            <form onSubmit={formik.handleSubmit}>
              <div className="edit-icon new-card-header justify-content-between">
                <div className="card-header">
                  Details{" "}
                  {dataLoading ? <i className="fas fa-cog fa-spin"></i> : ""}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-2">
                  <div className="form-group-blk mb-3">
                    <TextInput
                      type="text"
                      label="Assessment Name"
                      required
                      title="Assessment Name"
                      placeholder="Enter Assessment Name"
                      name="AssessmentName"
                      id="AssessmentName"
                      value={formik.values.AssessmentName || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={Boolean(
                        formik.errors.AssessmentName &&
                        formik.touched.AssessmentName
                      )}
                      errorText={
                        formik.touched.AssessmentName
                          ? formik.errors.AssessmentName
                          : undefined
                      }
                    />
                  </div>
                </div>

                <div className="col-md-6 col-lg-2">
                  <div className="form-group-blk mb-3">
                    <TextInput
                      type="text"
                      label="Code"
                      required
                      title="Code"
                      placeholder="Enter Code"
                      name="Code"
                      id="Code"
                      value={formik.values.Code || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={Boolean(
                        formik.errors.Code &&
                        formik.touched.Code
                      )}
                      errorText={
                        formik.touched.Code
                          ? formik.errors.Code
                          : undefined
                      }
                    />
                  </div>
                </div>

                <div className="col-md-6 col-lg-2">
                  <div className="form-group-blk mb-3">
                    <SelectDropdown
                      label="Type"
                      required
                      name="AssessmentType"
                      id="AssessmentType"
                      title="Assessment Type"
                      placeholder="Select Type"
                      options={assessmentType.sort(
                        sort_by("label", false, (a) => a.toUpperCase())
                      )}
                      value={formik.values.AssessmentType ?? ""}
                      onChange={(event) => {
                        const value = event.target.value;

                        if (value !== "") {
                          formik.setFieldValue("AssessmentType", value);
                          formik.setFieldValue("override_mark_ass_id", "");
                          setassessmentTypeSelected(value);

                          if (
                            value == 9 ||
                            (value != 9 && formik.values.AssessmentType == 9)
                          ) {
                            setCheckedAllRows([]);
                            setTempCheckedAllData([]);
                            setLinkCourseData([]);
                            setLinkCheckedAllRows([]);
                          }
                        } else {
                          formik.setFieldValue("AssessmentType", "");
                          formik.setFieldValue("override_mark_ass_id", "");
                          setCheckedAllRows([]);
                          setTempCheckedAllData([]);

                          if (formik.values.AssessmentType == 9) {
                            setLinkCourseData([]);
                            setLinkCheckedAllRows([]);
                          }

                          setassessmentTypeSelected("");
                        }
                      }}
                      disabled={
                        type === "open" &&
                        (formik.values.AssessmentType === 9 ||
                          formik.values.AssessmentType === 8)
                      }
                      clearable
                      error={Boolean(
                        formik.errors.AssessmentType &&
                        formik.touched.AssessmentType
                      )}
                      errorText={
                        formik.touched.AssessmentType
                          ? formik.errors.AssessmentType
                          : undefined
                      }
                    />
                  </div>
                </div>

                {props.lmType !== "selfplaced" ? (
                  <>
                    {props.gradingStandard != 2 ? <div className="col-md-6 col-lg-2">
                      <div className="form-group-blk mb-3">
                        <DateInput
                          label="Open Date & Time"
                          required
                          type="datetime-local"
                          name="openDateAndTime"
                          id="OpenDate"
                          value={formik.values.openDateAndTime}
                          onChange={(e) => {
                            formik.setFieldValue("openDateAndTime", e.target.value);
                          }}
                          onBlur={formik.handleBlur}
                          error={
                            !!formik.errors.openDateAndTime &&
                            !!formik.touched.openDateAndTime
                          }
                          errorText={
                            formik.errors.openDateAndTime &&
                              formik.touched.openDateAndTime
                              ? formik.errors.openDateAndTime
                              : ""
                          }
                        />
                      </div>
                    </div>
                      : <div className="col-md-6 col-lg-2">
                        <div className="form-group-blk mb-3">
                          <DateInput
                            label="Open Date & Time"
                            required
                            type="datetime-local"
                            name="openDateAndTime"
                            id="OpenDate"
                            value={formik.values.openDateAndTime}
                            onChange={(e) => {
                              formik.setFieldValue("openDateAndTime", e.target.value);
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              !!formik.errors.openDateAndTime &&
                              !!formik.touched.openDateAndTime
                            }
                            errorText={
                              formik.errors.openDateAndTime &&
                                formik.touched.openDateAndTime
                                ? formik.errors.openDateAndTime
                                : ""
                            }
                          />
                        </div>
                      </div>
                    }
                    <div className="col-md-6 col-lg-2">
                      <div className="form-group-blk mb-3">
                        <DateInput
                          label="Close Date & Time"
                          required
                          type="datetime-local"
                          name="closeDateAndTime"
                          id="CloseDate"
                          value={formik.values.closeDateAndTime}
                          onChange={async (e) => {
                            const date = e.target.value;

                            formik.setFieldValue("closeDateAndTime", date);
                            formik.setFieldValue("appealOpenDate", date);

                            if (date) {
                              const d = new Date(date);
                              const dAppeal = new Date(date);

                              d.setDate(d.getDate() + 14);
                              dAppeal.setDate(dAppeal.getDate() + 7);

                              formik.setFieldValue("deadlineDateAndTime", d);
                              formik.setFieldValue("appealCloseDate", dAppeal);
                            } else {
                              formik.setFieldValue("deadlineDateAndTime", "");
                              formik.setFieldValue("appealCloseDate", "");
                            }

                            await new Promise((resolve) => setTimeout(resolve, 0));

                            formik.validateField("closeDateAndTime");
                            formik.validateField("deadlineDateAndTime");
                          }}
                          onBlur={formik.handleBlur}
                          error={
                            !!formik.errors.closeDateAndTime &&
                            !!formik.touched.closeDateAndTime
                          }
                          errorText={
                            formik.errors.closeDateAndTime &&
                              formik.touched.closeDateAndTime
                              ? formik.errors.closeDateAndTime
                              : ""
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : null}
                {props.lmType !== "selfplaced" ? (
                  <div className="col-md-6 col-lg-2">
                    <div className="form-group-blk mb-3">
                      <DateInput
                        label="Marking Deadline Date & Time"
                        type="datetime-local"
                        name="deadlineDateAndTime"
                        id="MarkingDeadLineDate"
                        value={
                          formik.values.deadlineDateAndTime
                            ? (() => {
                              const date = new Date(formik.values.deadlineDateAndTime);

                              if (Number.isNaN(date.getTime())) return "";

                              const pad = (value) => String(value).padStart(2, "0");

                              return `${date.getFullYear()}-${pad(
                                date.getMonth() + 1
                              )}-${pad(date.getDate())}T${pad(
                                date.getHours()
                              )}:${pad(date.getMinutes())}`;
                            })()
                            : ""
                        }
                        onChange={() => { }}
                        onBlur={formik.handleBlur}
                        disabled
                        error={
                          !!formik.errors.deadlineDateAndTime &&
                          !!formik.touched.deadlineDateAndTime
                        }
                        errorText={
                          formik.errors.deadlineDateAndTime &&
                            formik.touched.deadlineDateAndTime
                            ? formik.errors.deadlineDateAndTime
                            : ""
                        }
                      />
                    </div>
                  </div>
                ) : null}
                {props.lmType !== "selfplaced" ? (
                  <div className="col-md-6 col-lg-2">
                    <div className="form-group-blk">
                      <div className="">
                        <label>&nbsp;</label>
                        <div className="custom-check-group">
                          <Checkbox
                            id="allowAppeal"
                            name="allowAppeal"
                            label="Enable Appeals"
                            checked={formik.values.allowAppeal}
                            onChange={(e) =>
                              formik.setFieldValue("allowAppeal", e.target.checked)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                {formik.values.allowAppeal == true && (
                  <>
                    <div className="col-md-6 col-lg-2">
                      <div className="form-group-blk mb-3">
                        <DateInput
                          label="Appeal Open Date"
                          type="datetime-local"
                          name="appealOpenDate"
                          id="MarkingDeadLineDate"
                          value={formik.values.appealOpenDate || formik.values.closeDateAndTime}
                          onChange={(e) => {
                            const date = e.target.value;

                            if (!date) {
                              formik.setFieldValue("appealOpenDate", "");
                              formik.setFieldValue("appealCloseDate", "");
                              return;
                            }

                            const dAppeal = new Date(date);
                            const d = new Date(dAppeal);

                            formik.setFieldValue("appealOpenDate", date);

                            d.setDate(d.getDate() + 7);
                            formik.setFieldValue("appealCloseDate", d);
                          }}
                          onBlur={formik.handleBlur}
                          disabled={!formik.values.closeDateAndTime}
                          min={formik.values.closeDateAndTime || undefined}
                          error={
                            !!formik.errors.appealOpenDate &&
                            !!formik.touched.appealOpenDate
                          }
                          errorText={
                            formik.errors.appealOpenDate &&
                              formik.touched.appealOpenDate
                              ? formik.errors.appealOpenDate
                              : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-2">
                      <div className="form-group-blk mb-3">
                        <DateInput
                          label="Appeal Close Date"
                          type="datetime-local"
                          name="appealCloseDate"
                          id="MarkingDeadLineDate"
                          title="Appeal Date & Time"
                          value={
                            formik.values.appealCloseDate
                              ? (() => {
                                const date = new Date(formik.values.appealCloseDate);
                                if (Number.isNaN(date.getTime())) return "";

                                const pad = (value) => String(value).padStart(2, "0");

                                return `${date.getFullYear()}-${pad(
                                  date.getMonth() + 1
                                )}-${pad(date.getDate())}T${pad(
                                  date.getHours()
                                )}:${pad(date.getMinutes())}`;
                              })()
                              : defaultAppealCloseDate
                                ? (() => {
                                  const date = new Date(defaultAppealCloseDate);
                                  if (Number.isNaN(date.getTime())) return "";

                                  const pad = (value) => String(value).padStart(2, "0");

                                  return `${date.getFullYear()}-${pad(
                                    date.getMonth() + 1
                                  )}-${pad(date.getDate())}T${pad(
                                    date.getHours()
                                  )}:${pad(date.getMinutes())}`;
                                })()
                                : ""
                          }
                          onChange={(e) => {
                            const value = e.target.value;

                            if (!value) {
                              const date = new Date(formik.values.appealOpenDate);
                              if (!Number.isNaN(date.getTime())) {
                                date.setDate(date.getDate() + 7);
                                formik.setFieldValue("appealCloseDate", date);
                              } else {
                                formik.setFieldValue("appealCloseDate", "");
                              }

                              return;
                            }

                            formik.setFieldValue("appealCloseDate", new Date(value));
                          }}
                          onBlur={formik.handleBlur}
                          disabled={type === "add" && !formik.values.closeDateAndTime}
                          min={
                            formik.values.appealOpenDate
                              ? (() => {
                                const date = new Date(formik.values.appealOpenDate);
                                if (Number.isNaN(date.getTime())) return "";

                                const pad = (value) => String(value).padStart(2, "0");

                                return `${date.getFullYear()}-${pad(
                                  date.getMonth() + 1
                                )}-${pad(date.getDate())}T${pad(
                                  date.getHours()
                                )}:${pad(date.getMinutes())}`;
                              })()
                              : undefined
                          }
                          placeholder="Select Date & Time"
                        />
                      </div>
                    </div>
                  </>
                )}
                {formik.values.AssessmentType == 8 || overrideMarkFor > 0 ? <div className="col-md-6 col-lg-2">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="maxGradeAchievable"> Maximum Grade Achievable *</label>
                    <input
                      type="number"
                      className={
                        "form-control" +
                        (formik.errors.maxGradeAchievable && formik.touched.maxGradeAchievable
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Maximum Grade Achievable"
                      name="maxGradeAchievable"
                      title="Maximum Grade Achievable"
                      id="maxGradeAchievable"
                      value={formik.values.maxGradeAchievable || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div> : ""}
                {formik.values.AssessmentType == 9 ?
                  <div className="search-filter-div-right mb-4">
                    <label>&nbsp;</label>
                    <div className="filter-search-bar-blk">
                      <div className="add-ticket-blk dropdown-comman">
                        <button data-toggle="modal" data-target="#overrideMarkFor" className={"btn btn-save btn-success " + (formik.errors.override_mark_ass_id && formik.touched.override_mark_ass_id ? " file-req is-invalid" : "")} type="button" title="Override Mark For" disabled={formik.values.AssessmentType == 9 && assignedStudentList.length && type == "open"}>
                          <i className="fal fa-history"></i>Override Mark For
                        </button>
                        {overrideAssessList.length && formik.values.override_mark_ass_id && formik.values.override_mark_ass_id != "" ?
                          <SelectedOverride />
                          : <></>}
                      </div>
                    </div>
                  </div> : null}

                {!formik.values.quizCheck && <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk">
                    <div className="">
                      <label>&nbsp;</label>
                      <div className="custom-check-group">
                        <Checkbox
                          id="isDownloadAllowed"
                          name="isDownloadAllowed"
                          label="Allow brief download after completion"
                          checked={!!formik.values.isDownloadAllowed}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "isDownloadAllowed",
                              e.target.checked
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>}
              </div>
              <hr />
              <div className="assessment-grade-setting-header">
                <div className="card-header" title="Grade Settings">
                  Grade Settings&nbsp;
                  {dataLoading ? <i className="fas fa-cog fa-spin"></i> : ""}
                </div>
                <PermissionsGate scopes={["caalinkcourse"]} errorProps={{ disabled: true }}>

                  <Button
                    data-toggle="modal"
                    data-target={
                      props.gradingStandard == 2 ? "#grademixmodal" : "#link-course-modal"
                    }
                    type="button"
                    title={
                      props.gradingStandard == 2 ? "Assign Grade Mix" : "Link Course"
                    }
                    variant="primary"
                    disabled={
                      assignLoading ||
                      formik.values.AssessmentType == 8 ||
                      (props.gradingStandard == 2 && formik.values.AssessmentType == 9) ||
                      moment(formik.values.openDateAndTime).isSameOrBefore(moment().add(1, "day"), "day")
                    }
                  >
                    {assignLoading ? (
                      <i className="fas fa-cog fa-spin" />
                    ) : (
                      <i
                        className={`fal fa-${props.gradingStandard == 2 ? "plus" : "link"
                          }`}
                      />
                    )}
                    {props.gradingStandard == 2 ? "Assign Grade Mix" : "Link Course"}
                  </Button>

                </PermissionsGate>
              </div>

              {props.gradingStandard == 2 ? <>
                <div>
                  <p>
                    <i className="fal fa-info-circle "></i> Assessments created
                    within Programmes using the “Grade Mix” Grading standard
                    require Grade Mix’s to be selected and grade settings to be
                    assigned individually to each Grade Mix to make up the total
                    assessment grade.
                  </p>
                </div>
                {tempCheckedAllData?.length ? (
                  tempCheckedAllData.map((gradeMix, index) => {
                    return (
                      <>
                        <div className="assessment-grade-setting-header">
                          <div className="card-header">
                            <Link
                              className="gradeMix-sidebar-color"
                              to={`/courseAdministration/gradeMix/${gradeMix?.qualification_id}/details/${type !== "add" ? gradeMix.grade_id : gradeMix.id}/open`}
                            >
                              <i className="fal fa-layer-group"></i>{" "}
                              {gradeMix?.name}
                            </Link>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 col-lg-2">
                            <div className="form-group-blk mb-3">
                              <SelectDropdown
                                label="Grade Type"
                                required
                                name={`GradeType_${gradeMix.id}`}
                                id={`GradeType_${gradeMix.id}`}
                                title="Grade Type"
                                placeholder="Grade Type"
                                options={gradeMixGradeType}
                                value={gradeMix.grading_type || ""}
                                disabled={formik.values.AssessmentType == 9}
                                clearable
                                error={Boolean(
                                  gradeMixError[index]?.field_name?.includes("Grade Type")
                                )}
                                onChange={(event) => {
                                  const value = event.target.value;

                                  setTempCheckedAllData((prevData) => {
                                    const newData = [...prevData];
                                    newData[index].grading_type = value || null;
                                    return newData;
                                  });

                                  tempCheckedAllData[index].pass_mark = "";
                                  setSelectedGradeMixTemplate({});
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-6 col-lg-2">
                            <div className="form-group-blk mb-3">
                              <TextInput
                                id={`AssessmentTotal_${gradeMix.id}`}
                                name={`AssessmentTotal_${gradeMix.id}`}
                                label="Assessment Total"
                                required
                                type="number"
                                min={0}
                                step={1}
                                disabled={quizLabel || formik.values.AssessmentType == 9}
                                placeholder="Enter Assessment Total"
                                title="Assessment Total"
                                value={gradeMix.assessment_total ?? ""}
                                onChange={(event) => {
                                  const value = event.target.value;

                                  if (value === "") {
                                    setTempCheckedAllData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index] = {
                                        ...newData[index],
                                        assessment_total: "",
                                      };
                                      return newData;
                                    });
                                    return;
                                  }

                                  const numericValue = Number(value);

                                  if (
                                    !Number.isFinite(numericValue) ||
                                    numericValue < 0 ||
                                    !Number.isInteger(numericValue)
                                  ) {
                                    return;
                                  }

                                  setTempCheckedAllData((prevData) => {
                                    const newData = [...prevData];
                                    newData[index] = {
                                      ...newData[index],
                                      assessment_total: value,
                                    };
                                    return newData;
                                  });
                                }}
                              />
                            </div>
                          </div>
                          {gradeMix?.aggregation_method_id == 6 && <div className="col-md-6 col-lg-1">
                            <div className="form-group-blk mb-3">

                              <TextInput
                                label="Weight"
                                type="number"
                                name={`weight_${gradeMix.id}`}
                                id={`weight_${gradeMix.id}`}
                                placeholder="Enter Weight"
                                title="Weight"
                                value={gradeMix?.ass_weighting || ""}
                                min={0}
                                required
                                onChange={(event) => {
                                  if (
                                    event.target &&
                                    event.target.value !== undefined
                                  ) {
                                    event.persist();

                                    setTempCheckedAllData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].ass_weighting =
                                        event.target.value || "";
                                      return newData;
                                    });
                                  }
                                }}
                                error={gradeMixError[index]?.field_name?.includes("Weight")}
                              />

                            </div>
                          </div>}
                          <div className={`col-md-6 ${gradeMix.aggregation_method_id == 6 ? "col-lg-1" : "col-lg-2"}`}>
                            <div className="form-group-blk mb-3">
                              <TextInput
                                id={`Offset_${gradeMix.id}`}
                                name={`Offset_${gradeMix.id}`}
                                label="Offset"
                                type="number"
                                step={1}
                                placeholder="Offset"
                                title="Offset"
                                info="Enter a value to be added to each student's raw score for this assignment. This can be used to adjust the difficulty of the assignment or to provide a bonus. For example, an offset of 5 would add 5 points to every student's score. A negative value can be used to subtract points. The default value is typically 0."
                                value={gradeMix?.offset ?? ""}
                                error={Boolean(
                                  gradeMixError[index]?.field_name?.includes("Offset")
                                )}
                                onChange={(event) => {
                                  if (
                                    event.target &&
                                    event.target.value !== undefined
                                  ) {
                                    const value = event.target.value;

                                    if (
                                      value !== "" &&
                                      !Number.isFinite(Number(value))
                                    ) {
                                      return;
                                    }

                                    setTempCheckedAllData((prevData) => {
                                      const newData = [...prevData];

                                      newData[index] = {
                                        ...newData[index],
                                        offset: value,
                                      };

                                      return newData;
                                    });
                                  }
                                }}
                              />
                              {gradeMixError[index]?.field_name?.includes("Offset") ? (
                                <span className="exclamation">
                                  <i className="fal fa-exclamation-circle"></i>
                                </span>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6 col-lg-2">
                            <div className="form-group-blk mb-3">

                              <TextInput
                                label={
                                  <>
                                    Multiplicator{" "}
                                    <i
                                      className="fal fa-info-circle grade-icon"
                                      title="Specify the factor by which the raw score of the assignment will be multiplied. This can be used to adjust the weight of the assignment in the overall grading scheme. For example, a multiplicator of 2 would double the score of this assignment in the context of overall grading. The default value is typically 1."
                                    />
                                  </>
                                }
                                type="number"
                                name={`multiplicator_${gradeMix.id}`}
                                id={`multiplicator_${gradeMix.id}`}
                                placeholder="Multiplicator"
                                title="Multiplicator"
                                min={0}
                                value={gradeMix.multiplicator || ""}
                                error={gradeMixError[index]?.field_name?.includes("Multiplicator")}
                                onChange={(event) => {
                                  if (
                                    event.target &&
                                    event.target.value !== undefined
                                  ) {
                                    event.persist();

                                    setTempCheckedAllData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].multiplicator = event.target.value;
                                      return newData;
                                    });
                                  }
                                }}
                              />

                              {gradeMixError[index]?.field_name?.includes("Multiplicator") ? (
                                <span className="exclamation">
                                  <i className="fal fa-exclamation-circle"></i>
                                </span>
                              ) : null}
                            </div>
                          </div>
                          {gradeMix.grading_type == "1" ? (
                            <div className="col-md-6 col-lg-2">
                              <div
                                className={
                                  "form-group-blk mb-3" +
                                  (gradeMixError[index]?.field_name?.includes("Pass Mark")
                                    ? " is-invalid"
                                    : "")
                                }
                              >
                                <label htmlFor={`pass_mark_${gradeMix.id}`}>
                                  Pass Mark&nbsp;
                                  <i
                                    className="fal fa-info-circle grade-icon"
                                    title="Pass Mark"
                                  ></i>
                                </label>
                                <Select
                                  className={
                                    "form-control custom-select-box" +
                                    (gradeMixError[index]?.field_name?.includes("Pass Mark")
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name={`pass_mark_${gradeMix.id}`}
                                  id={`pass_mark_${gradeMix.id}`}
                                  title="Pass Mark"
                                  value={passMarkRobotArr.find((option) => option.value == parseInt(gradeMix.pass_mark)) || null}
                                  onChange={(value) => {
                                    setTempCheckedAllData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].pass_mark =
                                        value?.value == 0
                                          ? 0
                                          : value?.value || "";
                                      return newData;
                                    });
                                  }}
                                  isClearable
                                  options={passMarkRobotArr}
                                  maxMenuHeight={175}
                                  placeholder={"Pass Mark"}
                                />
                              </div>
                            </div>
                          ) : gradeMix.grading_type == "2" ? (
                            <div className="col-md-6 col-lg-2">
                              <div
                                className={
                                  "form-group-blk mb-3" +
                                  (gradeMixError[index]?.field_name?.includes("Pass Mark")
                                    ? " is-invalid"
                                    : "")
                                }
                              >
                                <label htmlFor={`pass_mark_${gradeMix.id}`}>
                                  Pass Mark&nbsp;
                                  <i
                                    className="fal fa-info-circle grade-icon"
                                    title="Pass Mark"
                                  ></i>
                                </label>
                                <Select
                                  className={
                                    "form-control custom-select-box" +
                                    (gradeMixError[index]?.field_name?.includes("Pass Mark")
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name={`pass_mark_${gradeMix.id}`}
                                  id={`pass_mark_${gradeMix.id}`}
                                  title="Pass Mark"
                                  value={gradeMix.templateOptions?.find((option) => option.value == gradeMix.pass_mark) || null}
                                  onChange={(value) => {
                                    setTempCheckedAllData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].pass_mark =
                                        value?.value || "";
                                      return newData;
                                    });
                                  }}
                                  isClearable
                                  options={gradeMix?.templateOptions}
                                  maxMenuHeight={175}
                                  placeholder={"Mark"}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="col-md-6 col-lg-2">
                              <div className="form-group-blk mb-3">
                                <label htmlFor={`pass_mark_${gradeMix.id}`}>
                                  {gradeMix.grading_type == "0" ? "Pass Mark % " : gradeMix.grading_type == "3" ? "Pass Mark Value " : "Pass Mark "}
                                  <i
                                    className="fal fa-info-circle grade-icon"
                                    title={gradeMix.grading_type == "0" ? "Pass Mark as Percentage" : gradeMix.grading_type == "3" ? "Pass Mark as Value" : "Pass Mark"}
                                  ></i>
                                </label>
                                <input
                                  type="number"
                                  className={
                                    "form-control" +
                                    (gradeMixError[index]?.field_name?.includes("Pass Mark")
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder="Pass Mark"
                                  name={`pass_mark_${gradeMix.id}`}
                                  title="Pass Mark"
                                  id={`pass_mark_${gradeMix.id}`}
                                  value={gradeMix.pass_mark || ""}
                                  onChange={(event) => {
                                    if (
                                      event.target &&
                                      event.target.value !== undefined
                                    ) {
                                      event.persist();
                                      setTempCheckedAllData((prevData) => {
                                        const newData = [...prevData];
                                        newData[index].pass_mark =
                                          event?.target?.value;
                                        return newData;
                                      });
                                    }
                                  }}
                                />
                                {gradeMix.grading_type == "0" ? <span className="percentage-sign">%</span> : ""}
                                {(gradeMixError[index]?.field_name?.includes("Pass Mark")) ? (
                                  <span className="exclamation">
                                    <i className="fal fa-exclamation-circle"></i>
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          )}
                          {gradeMix.grading_type == "2" && (
                            <div className="search-filter-div-right mb-4">
                              <label>&nbsp;</label>
                              <div className="filter-search-bar-blk">
                                <div className="add-ticket-blk dropdown-comman">
                                  <button
                                    id={`lettertemplate_${gradeMix.id}`}
                                    data-toggle="modal"
                                    data-target="#letterTemplatemodal"
                                    className="btn btn-save btn-success"
                                    type="button"
                                    title="Select Template"
                                    onClick={() => {
                                      setLettertemplateIndex(index);
                                      setReload(!reload);
                                    }}
                                  >
                                    <i className="fal fa-file-alt"></i>Select
                                    Template
                                  </button>
                                  {gradeMix?.selectedTemplate && (
                                    <>
                                      {gradeMix.selectedTemplate &&
                                        gradeMix.selectedTemplate.name && (
                                          <div className="d-flex select-delete">
                                            <Link
                                              className="as-text-blue curser"
                                              title="Open"
                                              to={`/courseAdministration/gradingTemplate/edit/${gradeMix?.selectedTemplate?.id}`}
                                            >
                                              <span className="textLimit100">
                                                {gradeMix.selectedTemplate.name}
                                              </span>
                                            </Link>
                                            <button
                                              className="btn btn-danger rounded-circle btn-dropdown-item"
                                              type="button"
                                              title="Delete"
                                              onClick={() => {
                                                setLettertemplateIndex(index);
                                                setSelectedGradeMixTemplate({});
                                                setTempCheckedAllData(
                                                  (prevData) => {
                                                    const newData = [
                                                      ...prevData,
                                                    ];
                                                    newData[
                                                      index
                                                    ].templateOptions = [];
                                                    newData[
                                                      index
                                                    ].pass_mark = "";
                                                    return newData;
                                                  }
                                                );
                                              }}
                                            >
                                              <i className="fal fa-trash-alt"></i>
                                            </button>
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    );
                  })
                ) : (
                  <></>
                )}
              </> : <>
                <div className="card-header" style={{ fontSize: "14px" }} title={intakeDetails?.name}>
                  {intakeDetails?.name}
                </div>
                <div className="row" style={{ columnGap: "30px", padding: "0px 15px" }}>

                  <div className="custom_col_width">
                    <div
                      className={`form-group-blk mb-3 ${formik.errors.GradeType && formik.touched.GradeType ? "is-invalid" : ""}`}
                      title="Grade Type"
                    >

                      <SelectDropdown
                        id="gradeType"
                        name="GradeType"
                        label="Grade Type"
                        placeholder="Grade Type"
                        options={gradeType}
                        value={formik.values.GradeType || ""}
                        onChange={(event) => {
                          const value = event.target.value;

                          if (value) {
                            formik.setFieldValue("GradeType", value);
                            setGradeSelected(value);
                            formik.setFieldValue("passMark", "");
                            formik.setFieldValue(
                              "AssessmentTotal",
                              quizTotal ? quizTotal : formik.values.AssessmentTotal
                            );
                            setSelectedTemplate({});
                          } else {
                            formik.setFieldValue("GradeType", "");
                            formik.setFieldValue("passMark", "");
                            setGradeSelected("");
                          }
                        }}
                        onBlur={() => formik.setFieldTouched("GradeType", true)}
                        required
                        error={
                          Boolean(
                            formik.errors.GradeType &&
                            formik.touched.GradeType
                          )
                        }
                        errorText={
                          formik.touched.GradeType
                            ? formik.errors.GradeType
                            : ""
                        }
                      />
                    </div>
                  </div>

                  {formik.values.GradeType != 4 && <>
                    <div className="custom_col_width">
                      <div className="form-group-blk mb-3" title="Assessment Total">
                        <TextInput
                          id="AssessmentTotal"
                          name="AssessmentTotal"
                          label="Assessment Total"
                          required
                          type="number"
                          min={0}
                          step={1}
                          disabled={quizLabel}
                          placeholder="Enter Assessment Total"
                          title="Assessment Total"
                          value={
                            formik.values.AssessmentTotal >= 0
                              ? formik.values.AssessmentTotal
                              : ""
                          }
                          onChange={(event) => {
                            const value = event.target.value;

                            if (value === "") {
                              formik.setFieldValue("AssessmentTotal", "");
                              return;
                            }

                            const numericValue = Number(value);

                            if (
                              !Number.isFinite(numericValue) ||
                              numericValue < 0 ||
                              !Number.isInteger(numericValue)
                            ) {
                              return;
                            }

                            formik.setFieldValue("AssessmentTotal", numericValue);
                          }}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                    </div>

                    <div className="custom_col_width">
                      <div className="form-group-blk mb-3" title="Offset">
                        <TextInput
                          id="offset"
                          name="offset"
                          label="Offset"
                          type="number"
                          step={1}
                          placeholder="Offset"
                          title="Offset"
                          info="Enter a value to be added to each student's raw score for this assignment. This can be used to adjust the difficulty of the assignment or to provide a bonus. For example, an offset of 5 would add 5 points to every student's score. A negative value can be used to subtract points. The default value is typically 0."
                          value={formik.values.offset ?? ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={Boolean(
                            formik.errors.offset && formik.touched.offset
                          )}
                          errorText={
                            formik.touched.offset
                              ? formik.errors.offset
                              : undefined
                          }
                        />
                        {formik.errors.offset && formik.touched.offset ? (
                          <span className="exclamation">
                            <i className="fal fa-exclamation-circle"></i>
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="custom_col_width">
                      <div className="form-group-blk mb-3" title="Multiplicator">

                        <TextInput
                          label={
                            <>
                              Multiplicator{" "}
                              <i
                                className="fal fa-info-circle grade-icon"
                                title="Specify the factor by which the raw score of the assignment will be multiplied. This can be used to adjust the weight of the assignment in the overall grading scheme. For example, a multiplicator of 2 would double the score of this assignment in the context of overall grading. The default value is typically 1."
                              />
                            </>
                          }
                          type="number"
                          name="multiplicator"
                          id="multiplicator"
                          placeholder="Multiplicator"
                          title="Multiplicator"
                          min={0}
                          value={formik.values.multiplicator || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            !!formik.errors.multiplicator &&
                            !!formik.touched.multiplicator
                          }
                          errorText={
                            formik.errors.multiplicator &&
                              formik.touched.multiplicator
                              ? formik.errors.multiplicator
                              : ""
                          }
                        />

                        {formik.errors.multiplicator &&
                          formik.touched.multiplicator ? (
                          <span className="exclamation">
                            <i className="fal fa-exclamation-circle"></i>
                          </span>
                        ) : null}
                      </div>
                    </div>

                    {intakeDetails?.aggregation_method_id == 6 && <div className="custom_col_width">
                      <div className="form-group-blk mb-3" title="Weight">
                        <TextInput
                          label="Weight"
                          type="number"
                          name="Weight"
                          id="Weight"
                          placeholder="Enter Weight"
                          title="Weight"
                          value={formik.values.Weight || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          min={0}
                          required
                          error={
                            !!formik.errors.Weight &&
                            !!formik.touched.Weight
                          }
                          errorText={
                            formik.errors.Weight &&
                              formik.touched.Weight
                              ? formik.errors.Weight
                              : ""
                          }
                        />
                        {formik.errors.Weight && formik.touched.Weight ? (
                          <span className="exclamation">
                            <i className="fal fa-exclamation-circle"></i>
                          </span>
                        ) : null}
                      </div>
                    </div>}

                    {gradeSelected == "1" ? (
                      <div className="custom_col_width">
                        <div className={`form-group-blk mb-3 ${formik.errors.passMark && formik.touched.passMark ? "is-invalid" : ""}`} title="Enter or select the minimum grade a student must achieve to pass this assignment.">

                          <TextInput
                            label={
                              <>
                                Pass Mark{" "}
                                <i
                                  className="fal fa-info-circle grade-icon"
                                  title="Enter or select the minimum grade a student must achieve to pass this assignment."
                                />
                              </>
                            }
                            type="number"
                            name="passMark"
                            id="passMark"
                            placeholder="Enter Pass Mark"
                            title="Pass Mark"
                            min={0}
                            required
                            value={formik.values.passMark ?? ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              !!formik.errors.passMark &&
                              !!formik.touched.passMark
                            }
                            errorText={
                              formik.errors.passMark &&
                                formik.touched.passMark
                                ? formik.errors.passMark
                                : ""
                            }
                          />
                        </div>
                      </div>
                    ) : gradeSelected == "2" ? (
                      <div className="custom_col_width">
                        <div className={`form-group-blk mb-3 ${formik.errors.passMark && formik.touched.passMark ? "is-invalid" : ""}`} title="Enter or select the minimum grade a student must achieve to pass this assignment.">

                          <TextInput
                            label={
                              <>
                                Pass Mark{" "}
                                <i
                                  className="fal fa-info-circle grade-icon"
                                  title="Enter or select the minimum grade a student must achieve to pass this assignment."
                                />
                              </>
                            }
                            type="number"
                            name="passMark"
                            id="passMark"
                            title="Pass Mark"
                            placeholder="Enter Pass Mark"
                            min={0}
                            required
                            value={formik.values.passMark ?? ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              !!formik.errors.passMark &&
                              !!formik.touched.passMark
                            }
                            errorText={
                              formik.touched.passMark
                                ? formik.errors.passMark
                                : ""
                            }
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="custom_col_width">
                        <div className={`form-group-blk mb-3 ${formik.errors.passMark && formik.touched.passMark ? "is-invalid" : ""}`} title="Enter or select the minimum grade a student must achieve to pass this assignment.">

                          <TextInput
                            label={
                              <>
                                {gradeSelected == "0"
                                  ? "Pass Mark %"
                                  : gradeSelected == "3"
                                    ? "Pass Mark Value"
                                    : "Pass Mark"}{" "}
                                *
                                <i
                                  className="fal fa-info-circle grade-icon"
                                  title="Enter or select the minimum grade a student must achieve to pass this assignment."
                                />
                              </>
                            }
                            type="number"
                            name="passMark"
                            id="passMark"
                            placeholder="Pass Mark"
                            title="Pass Mark"
                            min={0}
                            required
                            value={formik.values.passMark || ""}
                            onChange={(e) => {
                              formik.setFieldValue("passMark", e.target.value);
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              !!formik.errors.passMark &&
                              !!formik.touched.passMark
                            }
                            errorText={
                              formik.errors.passMark &&
                                formik.touched.passMark
                                ? formik.errors.passMark
                                : ""
                            }
                          />

                          {formik.errors.passMark && formik.touched.passMark ? (
                            <span className="exclamation">
                              <i className="fal fa-exclamation-circle"></i>
                            </span>
                          ) : null}
                        </div>
                      </div>
                    )}

                    {gradeSelected == "2" && (
                      <div className="search-filter-div-right mb-4" style={{ marginLeft: 0 }}>
                        <label>&nbsp;</label>
                        <div className="filter-search-bar-blk">
                          <div className="add-ticket-blk dropdown-comman">
                            <button
                              data-toggle="modal"
                              data-target="#letterTemplatemodal"
                              className="btn btn-save btn-success"
                              type="button"
                              title="Select Template"
                              onClick={() => setLetterTemplateCourse(false)}
                            >
                              <i className="fal fa-file-alt"></i>Select Template
                            </button>
                            {selectedTemplate && (
                              <>
                                {selectedTemplate && selectedTemplate?.name && (
                                  <div className="d-flex select-delete" style={{ position: "relative" }}>
                                    <Link
                                      className="as-text-blue curser"
                                      title={selectedTemplate?.name}
                                      to={`/courseAdministration/gradingTemplate/edit/${selectedTemplate?.id}`}
                                      target="_blank"
                                    >
                                      <span className="textLimit100">
                                        {TrimText(selectedTemplate?.name, 20)}
                                      </span>
                                    </Link>
                                    <button
                                      className="btn btn-danger rounded-circle btn-dropdown-item"
                                      title="Delete"
                                      onClick={() => {
                                        formik.setFieldValue("passMark", "");
                                        setSelectedTemplate({})
                                      }}
                                    >
                                      <i className="fal fa-trash-alt"></i>
                                    </button>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="custom_col_width">
                      <div className="form-group-blk" title="Pass Required">
                        <div>
                          <label htmlFor="isPassRequired">&nbsp;</label>
                          <div className="custom-check-group">
                            <div className="custom-check custom-control custom-checkbox mt-2">
                              <Checkbox
                                id="pass_required"
                                name="pass_required"
                                label="Pass Required"
                                checked={formik.values.pass_required == 1}
                                onChange={(e) =>
                                  formik.setFieldValue(
                                    "pass_required",
                                    e.target.checked ? 1 : 0
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {intakeDetails?.aggregation_method_id != 6 && <div className="custom_col_width">
                      <div className="form-group-blk" title="Exclude from Calculation">
                        <div>
                          <label htmlFor="exlcude_from_calculation">&nbsp;</label>
                          <div className="custom-check-group">
                            <div className="custom-check custom-control custom-checkbox mt-2">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="exclude_from_calculation"
                                name="exclude_from_calculation"
                                checked={formik.values.exclude_from_calculation == 1}
                                onChange={(e) => formik.setFieldValue("exclude_from_calculation", e.target.checked ? 1 : 0)}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="exclude_from_calculation"
                              >
                                <div className="mr-3"></div> Exclude from Calculation
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>}
                  </>
                  }
                </div>
                {linkCourseData?.length ? linkCourseData.map((courseLink, index) => {
                  if (courseLink.intake == id || courseLink.isDelete == 1) return null;
                  return (
                    <div key={courseLink.id}>
                      <div className="assessment-grade-setting-header mt-3">
                        <div className="card-header" style={{ fontSize: "14px" }} title={courseLink?.name}>
                          <Link
                            target="_blank"
                            to={`/courseAdministration/coursesdetails/${courseLink.intake ? courseLink.intake : courseLink.intakeID}/detailCourses/show`}
                          >
                            {courseLink?.name}
                          </Link>
                        </div>
                        <div className="d-flex btn-dropdown-grp">
                          <div className="as-buttons">
                            <PermissionsGate scopes={["caaunlinkcourse"]} errorProps={{ disabled: true }}>
                              <button
                                type="button"
                                className="btn btn-danger rounded-circle btn-dropdown-item"
                                title="Remove Course"
                                onClick={() => {
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "You want to unassign this course!",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      const courseToRemove = linkCourseData.find(course => course.id === courseLink?.id);

                                      if (courseToRemove?.newData) {
                                        setLinkCourseData(prev => prev.filter(course => course.id !== courseLink?.id));
                                      } else {
                                        setLinkCourseData(prev => {
                                          const updated = prev.map(course =>
                                            course.id === courseLink?.id
                                              ? { ...course, isDelete: 1 }
                                              : course
                                          );
                                          return updated;
                                        });
                                      }
                                      setLinkCheckedAllRows(prev => prev.filter(id => id !== courseLink?.id));
                                    }
                                  })
                                }}
                              >
                                <i className="fal fa-unlink"></i>
                              </button>
                            </PermissionsGate>
                          </div>

                          <div className="as-buttons">
                            <Link
                              type="button"
                              className="btn btn-save rounded-circle btn-dropdown-item"
                              title="Open"
                              target="_blank"
                              to={`/courseAdministration/coursesdetails/${courseLink.intake ? courseLink.intake : courseLink.intakeID}/detailCourses/show`}
                            >
                              <i className="fal fa-folder-open"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ columnGap: "30px", padding: "0px 15px" }}>
                        <div className="custom_col_width">
                          <div className={`form-group-blk mb-3 ${courseError[index]?.field_name?.includes("Grade Type") ? "is-invalid" : ""}`} title="Grade Type">
                            <label htmlFor={`gradeType_${courseLink.id}`}>
                              Grade Type *
                            </label>
                            <Select
                              className={`form-control custom-select-box ${touchedStates[index]?.gradeType && courseError[index]?.field_name?.includes("Grade Type") ? "is-invalid" : ""}`}
                              name={`gradeType_${courseLink.id}`}
                              id={`gradeType_${courseLink.id}`}
                              title="Grade Type"
                              placeholder={"Grade Type"}
                              options={gradeType}
                              isClearable
                              onBlur={() => {
                                formik.setFieldTouched("linkAssessmentCourse", true)

                                setTouchedStates(prev => {
                                  const isEmpty = !linkCourseData[index]?.grading_type;

                                  const newState = [...prev];
                                  newState[index] = {
                                    ...newState[index],
                                    gradeType: isEmpty
                                  };
                                  return newState;
                                })
                              }}
                              onChange={(value) => {
                                setLinkCourseData((prevData) => {
                                  const newData = [...prevData];
                                  newData[index].grading_type = value?.value;
                                  newData[index].assessment_total = quizTotal ? quizTotal : courseLink.assessment_total;
                                  return newData;
                                });
                                linkCourseData[index].pass_mark = "";
                                linkCourseData[index].templateOptions = [];
                                setLettertemplateIndex(index);
                                setSelectedCourse({})

                                setTouchedStates(prev => {
                                  const newState = [...prev];
                                  newState[index] = {
                                    ...newState[index],
                                    gradeType: false
                                  };
                                  return newState;
                                })

                                formik.setFieldTouched("linkAssessmentCourse", true)
                              }}
                              value={gradeType.filter((option) => option.value == courseLink.grading_type)}
                            />
                          </div>
                        </div>
                        {courseLink?.grading_type != 4 && <>
                          <div className="custom_col_width">
                            <div className="form-group-blk mb-3" title="Assessment Total">
                              <TextInput
                                id={`AssessmentTotal_${courseLink.id}`}
                                name={`AssessmentTotal_${courseLink.id}`}
                                label="Assessment Total"
                                required
                                type="number"
                                min={0}
                                step={1}
                                disabled={quizLabel}
                                placeholder="Enter Assessment Total"
                                value={courseLink.assessment_total ?? ""}
                                onBlur={() => {
                                  formik.setFieldTouched("linkAssessmentCourse", true);

                                  setTouchedStates((prev) => {
                                    const isEmpty =
                                      !linkCourseData[index]?.assessment_total ||
                                      linkCourseData[index]?.assessment_total == 0;

                                    const newState = [...prev];
                                    newState[index] = {
                                      ...newState[index],
                                      assessmentTotal: isEmpty,
                                    };

                                    return newState;
                                  });
                                }}
                                onChange={(event) => {
                                  const value = event.target.value;

                                  if (value !== "") {
                                    const numericValue = Number(value);

                                    if (
                                      !Number.isFinite(numericValue) ||
                                      numericValue < 0 ||
                                      !Number.isInteger(numericValue)
                                    ) {
                                      return;
                                    }
                                  }

                                  setLinkCourseData((prevData) => {
                                    const newData = [...prevData];
                                    newData[index] = {
                                      ...newData[index],
                                      assessment_total: value,
                                    };
                                    return newData;
                                  });

                                  setTouchedStates((prev) => {
                                    const newState = [...prev];
                                    newState[index] = {
                                      ...newState[index],
                                      assessmentTotal: false,
                                    };
                                    return newState;
                                  });

                                  formik.setFieldTouched("linkAssessmentCourse", true);
                                }}
                              />
                            </div>
                          </div>
                          <div className={`custom_col_width`}>
                            <div className="form-group-blk mb-3" title="Offset">
                              <TextInput
                                id={`Offset_${courseLink.id}`}
                                name={`Offset_${courseLink.id}`}
                                label="Offset"
                                type="number"
                                step={1}
                                placeholder="Offset"
                                title="Offset"
                                info="Enter a value to be added to each student's raw score for this assignment. This can be used to adjust the difficulty of the assignment or to provide a bonus. For example, an offset of 5 would add 5 points to every student's score. A negative value can be used to subtract points. The default value is typically 0."
                                value={courseLink?.offset ?? ""}
                                error={Boolean(
                                  courseError[index]?.field_name?.includes("Offset")
                                )}
                                onChange={(event) => {
                                  const value = event.target.value;

                                  if (value !== "" && !Number.isFinite(Number(value))) {
                                    return;
                                  }

                                  setLinkCourseData((prevData) => {
                                    const newData = [...prevData];

                                    newData[index] = {
                                      ...newData[index],
                                      offset: value,
                                    };

                                    return newData;
                                  });

                                  formik.setFieldTouched("linkAssessmentCourse", true);
                                }}
                              />
                              {gradeMixError[index]?.field_name?.includes("Offset") ? (
                                <span className="exclamation">
                                  <i className="fal fa-exclamation-circle"></i>
                                </span>
                              ) : null}
                            </div>
                          </div>
                          <div className="custom_col_width">
                            <div className="form-group-blk mb-3" title="Multiplicator">

                              <TextInput
                                label={
                                  <>
                                    Multiplicator{" "}
                                    <i
                                      className="fal fa-info-circle grade-icon"
                                      title="Specify the factor by which the raw score of the assignment will be multiplied. This can be used to adjust the weight of the assignment in the overall grading scheme. For example, a multiplicator of 2 would double the score of this assignment in the context of overall grading. The default value is typically 1."
                                    />
                                  </>
                                }
                                type="number"
                                name={`multiplicator_${courseLink.id}`}
                                id={`multiplicator_${courseLink.id}`}
                                placeholder="Multiplicator"
                                title="Multiplicator"
                                min={0}
                                value={courseLink.multiplicator || ""}
                                onChange={(event) => {
                                  if (
                                    event.target &&
                                    event.target.value !== undefined
                                  ) {
                                    event.persist();

                                    setLinkCourseData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].multiplicator = event.target.value;
                                      return newData;
                                    });

                                    formik.setFieldTouched("linkAssessmentCourse", true);
                                  }
                                }}
                                error={courseError[index]?.field_name?.includes("Multiplicator")}
                              />

                              {gradeMixError[index]?.field_name?.includes("Multiplicator") ? (
                                <span className="exclamation">
                                  <i className="fal fa-exclamation-circle"></i>
                                </span>
                              ) : null}
                            </div>
                          </div>
                          {courseLink?.aggregation_method_id == 6 && <div className="custom_col_width">
                            <div className="form-group-blk mb-3" title="Weight">

                              <TextInput
                                label="Weight"
                                type="number"
                                name={`weight_${courseLink.id}`}
                                id={`weight_${courseLink.id}`}
                                placeholder="Enter Weight"
                                title="Weight"
                                value={courseLink?.weight ?? ""}
                                min={0}
                                required
                                error={
                                  !!touchedStates[index]?.weight &&
                                  !!courseError[index]?.field_name?.includes("Weight")
                                }
                                onBlur={() => {
                                  formik.setFieldTouched("linkAssessmentCourse", true);

                                  setTouchedStates((prev) => {
                                    const isEmpty = !linkCourseData[index]?.weight;
                                    const newState = [...prev];

                                    newState[index] = {
                                      ...newState[index],
                                      weight: isEmpty,
                                    };

                                    return newState;
                                  });
                                }}
                                onChange={(event) => {
                                  if (
                                    event.target &&
                                    event.target.value !== undefined
                                  ) {
                                    event.persist();

                                    setLinkCourseData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].weight = event.target.value;
                                      return newData;
                                    });

                                    setTouchedStates((prev) => {
                                      const newState = [...prev];

                                      newState[index] = {
                                        ...newState[index],
                                        weight: true,
                                      };

                                      return newState;
                                    });

                                    formik.setFieldTouched("linkAssessmentCourse", true);
                                  }
                                }}
                              />

                            </div>
                          </div>}

                          {courseLink?.grading_type == 1 ? (
                            <div className="custom_col_width">
                              <div className={`form-group-blk mb-3 ${touchedStates[index]?.passMark && courseError[index]?.field_name?.includes("Pass Mark") ? "is-invalid" : ""}`} title="Enter or select the minimum grade a student must achieve to pass this assignment.">
                                <TextInput
                                  label={
                                    <>
                                      Pass Mark{" "}
                                      <i
                                        className="fal fa-info-circle grade-icon"
                                        title="Enter or select the minimum grade a student must achieve to pass this assignment."
                                      />
                                      *
                                    </>
                                  }
                                  type="number"
                                  name={`pass_mark_${courseLink.id}`}
                                  id={`pass_mark_${courseLink.id}`}
                                  title="Pass Mark"
                                  placeholder="Pass Mark"
                                  min={0}
                                  required
                                  value={courseLink.pass_mark ?? ""}
                                  onBlur={() => {
                                    formik.setFieldTouched("linkAssessmentCourse", true);

                                    setTouchedStates((prev) => {
                                      const isEmpty = !linkCourseData[index]?.pass_mark;
                                      const newState = [...prev];

                                      newState[index] = {
                                        ...newState[index],
                                        passMark:
                                          courseLink.pass_mark >= courseLink.assessment_total
                                            ? true
                                            : isEmpty,
                                      };

                                      return newState;
                                    });
                                  }}
                                  onChange={(event) => {
                                    if (
                                      event.target &&
                                      event.target.value !== undefined
                                    ) {
                                      event.persist();

                                      setLinkCourseData((prevData) => {
                                        const newData = [...prevData];
                                        newData[index].pass_mark = event.target.value;
                                        return newData;
                                      });

                                      setTouchedStates((prev) => {
                                        const newState = [...prev];

                                        newState[index] = {
                                          ...newState[index],
                                          passMark: false,
                                        };

                                        return newState;
                                      });

                                      formik.setFieldTouched("linkAssessmentCourse", true);
                                    }
                                  }}
                                  error={
                                    !!touchedStates[index]?.passMark &&
                                    !!courseError[index]?.field_name?.includes("Pass Mark")
                                  }
                                />
                              </div>
                            </div>
                          ) : courseLink?.grading_type == 2 ? (
                            <div className="custom_col_width">
                              <div className={`form-group-blk mb-3 ${touchedStates[index]?.passMark && courseError[index]?.field_name?.includes("Pass Mark") ? "is-invalid" : ""}`} title="Enter or select the minimum grade a student must achieve to pass this assignment.">
                                <TextInput
                                  label={
                                    <>
                                      Pass Mark
                                      <i
                                        className="fal fa-info-circle grade-icon"
                                        title="Enter or select the minimum grade a student must achieve to pass this assignment."
                                      />
                                    </>
                                  }
                                  type="number"
                                  name={`pass_mark_${courseLink.id}`}
                                  id={`pass_mark_${courseLink.id}`}
                                  title="Pass Mark"
                                  placeholder="Mark"
                                  min={0}
                                  required
                                  value={courseLink.pass_mark ?? ""}
                                  onBlur={() => {
                                    formik.setFieldTouched("linkAssessmentCourse", true);

                                    setTouchedStates((prev) => {
                                      const isEmpty = !linkCourseData[index]?.pass_mark;
                                      const newState = [...prev];

                                      newState[index] = {
                                        ...newState[index],
                                        passMark:
                                          courseLink.pass_mark >= courseLink.assessment_total
                                            ? true
                                            : isEmpty,
                                      };

                                      return newState;
                                    });
                                  }}
                                  onChange={(event) => {
                                    setLinkCourseData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].pass_mark = event.target.value;
                                      return newData;
                                    });

                                    setTouchedStates((prev) => {
                                      const newState = [...prev];
                                      newState[index] = {
                                        ...newState[index],
                                        passMark: false,
                                      };
                                      return newState;
                                    });

                                    formik.setFieldTouched("linkAssessmentCourse", true);
                                  }}
                                  error={
                                    !!touchedStates[index]?.passMark &&
                                    !!courseError[index]?.field_name?.includes("Pass Mark")
                                  }
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="custom_col_width">
                              <div className="form-group-blk mb-3" title="Enter or select the minimum grade a student must achieve to pass this assignment.">
                                <label htmlFor={`pass_mark_${courseLink.id}`}>
                                  {`Pass Mark ${courseLink?.grading_type == "0" ? "%" : courseLink?.grading_type == "3" ? "Value" : ""} *`}&nbsp;
                                  <i
                                    className="fal fa-info-circle grade-icon"
                                    title="Enter or select the minimum grade a student must achieve to pass this assignment."
                                  ></i>
                                </label>
                                <input
                                  type="number"
                                  className={`form-control ${touchedStates[index]?.passMark && courseError[index]?.field_name?.includes("Pass Mark") ? "is-invalid" : ""}`}
                                  placeholder="Pass Mark"
                                  name={`pass_mark_${courseLink.id}`}
                                  title="Pass Mark"
                                  id={`pass_mark_${courseLink.id}`}
                                  value={courseLink.pass_mark || ""}
                                  onBlur={() => {
                                    formik.setFieldTouched("linkAssessmentCourse", true)

                                    setTouchedStates(prev => {
                                      const isEmpty = !linkCourseData[index]?.pass_mark;

                                      const newState = [...prev];
                                      newState[index] = {
                                        ...newState[index],
                                        passMark: courseLink.pass_mark >= courseLink.assessment_total ? true : isEmpty
                                      };
                                      return newState;
                                    })
                                  }}
                                  onChange={(event) => {
                                    if (
                                      event.target &&
                                      event.target.value !== undefined
                                    ) {
                                      event.persist();
                                      setLinkCourseData((prevData) => {
                                        const newData = [...prevData];
                                        newData[index].pass_mark = event?.target?.value;
                                        return newData;
                                      });

                                      setTouchedStates(prev => {
                                        const newState = [...prev];
                                        newState[index] = {
                                          ...newState[index],
                                          passMark: false
                                        };
                                        return newState;
                                      })

                                      formik.setFieldTouched("linkAssessmentCourse", true)
                                    }
                                  }}
                                />
                                {(courseError[index]?.field_name?.includes("Pass Mark")) ? (
                                  <span className="exclamation">
                                    <i className="fal fa-exclamation-circle"></i>
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          )}

                          {courseLink?.grading_type == 2 && (
                            <div className="search-filter-div-right mb-4" style={{ marginLeft: 0 }}>
                              <label>&nbsp;</label>
                              <div className="filter-search-bar-blk">
                                <div className="add-ticket-blk dropdown-comman">
                                  <button
                                    id={`lettertemplate_${courseLink.id}`}
                                    data-toggle="modal"
                                    data-target="#letterTemplatemodal"
                                    className="btn btn-save btn-success"
                                    type="button"
                                    title="Select Template"
                                    // disabled={props.gradingStandard == 2}
                                    onClick={() => {
                                      const isEmpty = (obj) => {
                                        return !obj || Object.keys(obj).length === 0;
                                      };

                                      if (courseLink?.newData && isEmpty(courseLink?.selectedTemplate)) {
                                        setSelectedCourse({})
                                      } else if (courseLink?.selectedTemplate) {
                                        setSelectedCourse(courseLink?.selectedTemplate)
                                      }

                                      setLettertemplateIndex(index);
                                      setReload(!reload);
                                      setLetterTemplateCourse(true)
                                    }}
                                  >
                                    <i className="fal fa-file-alt"></i> Select
                                    Template
                                  </button>
                                  {courseLink?.selectedTemplate && (
                                    <>
                                      {courseLink?.selectedTemplate &&
                                        courseLink?.selectedTemplate?.name && (
                                          <div className="d-flex select-delete" style={{ position: "relative" }}>
                                            <Link
                                              className="as-text-blue curser"
                                              title="Open"
                                              to={`/courseAdministration/gradingTemplate/edit/${courseLink?.selectedTemplate?.id}`}
                                              onClick={() => {
                                                $("#letterTemplatemodal").modal("hide");
                                              }}
                                            >
                                              <span className="textLimit100">
                                                {courseLink?.selectedTemplate?.name}
                                              </span>
                                            </Link>
                                            <button
                                              className="btn btn-danger rounded-circle btn-dropdown-item"
                                              type="button"
                                              title="Delete"
                                              onClick={() => {
                                                setLettertemplateIndex(index);
                                                setSelectedCourse({})
                                                setLinkCourseData((prevData) => {
                                                  const newData = [...prevData];
                                                  newData[index].selectedTemplate = null;
                                                  newData[index].templateOptions = [];
                                                  newData[index].pass_mark = "";
                                                  return newData;
                                                }
                                                );

                                                formik.setFieldTouched("linkAssessmentCourse", true)
                                              }}
                                            >
                                              <i className="fal fa-trash-alt"></i>
                                            </button>
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="custom_col_width">
                            <div className="form-group-blk">
                              <div>
                                <label>&nbsp;</label>
                                <div className="custom-check-group">
                                  <div className="custom-check custom-control custom-checkbox mt-2">
                                    <Checkbox
                                      id={`pass_required${courseLink.id}`}
                                      name={`pass_required${courseLink.id}`}
                                      label="Pass Required"
                                      checked={courseLink?.pass_required == 1}
                                      onChange={(e) => {
                                        setLinkCourseData((prevData) => {
                                          const newData = [...prevData];
                                          newData[index].pass_required = e.target.checked ? 1 : 0;
                                          return newData;
                                        });
                                        formik.setFieldTouched("linkAssessmentCourse", true);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {courseLink?.aggregation_method_id != 6 && <div className="custom_col_width">
                            <div className="form-group-blk">
                              <div>
                                <label>&nbsp;</label>
                                <div className="custom-check-group">
                                  <div className="custom-check custom-control custom-checkbox mt-2">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id={`exclude_from_calculation${courseLink.id}`}
                                      name={`exclude_from_calculation${courseLink.id}`}
                                      checked={courseLink?.exclude_from_calculation == 1}
                                      onChange={(e) => {
                                        setLinkCourseData((prevData) => {
                                          const newData = [...prevData];
                                          newData[index].exclude_from_calculation = e.target.checked ? 1 : 0;
                                          return newData;
                                        })

                                        formik.setFieldTouched("linkAssessmentCourse", true)
                                      }
                                      }
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor={`exclude_from_calculation${courseLink.id}`}
                                    >
                                      <div className="mr-3"></div> Exclude from Calculation
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>}
                        </>
                        }
                      </div>
                    </div>
                  );
                }
                )
                  : null}
              </>
              }
              <hr />
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group-blk mb-3">
                    <label>Detailed instructions</label>
                    {(apiDataLoaded || type == "add") && (
                      <HtmlInputEditor
                        editorState={editorState}
                        setEditorState={setEditorState}
                        // readOnly={assessmentActive}
                        isInValid={editorState}
                        isCKEditor={true}
                        hideSign={true}
                      />
                    )}
                    {formik.errors.DetailedInstruction &&
                      formik.touched.DetailedInstruction ? (
                      <span className="exclamation">
                        <i className="fal fa-exclamation-circle"></i>
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
              {formik.values.AssessmentType == 8 || formik.values.AssessmentType == 9 ? <>
                <hr />
                <div className="edit-icon new-card-header">
                  <div className="card-header">Assigned Students</div>
                </div>
                <DataTableComponentFrontPagination
                  isInsidePopUp
                  data={dataToRenderAssignedStd()}
                  columns={studentColumns}
                  loading={assignloading}
                  exportData={exportDataAssignedStd}
                  search={searchAssigned}
                  setSearch={setSearchAssigned}
                  exportFileName="Assigned_Students"
                  tableButton={[
                    <button className="btn btn-primary" title="Assign Students" type="button" data-toggle="modal" data-target="#availableStudents" disabled={(formik.values.AssessmentType == 9 && !formik.values.override_mark_ass_id)}>
                      <i className="fal fa-plus"></i>Assign Students
                    </button>
                  ]}
                  filters={[
                    {
                      filterName: "Status",
                      optionArr: statusAssignedList,
                      state: statusAssigned,
                      setState: setStatusAssigned,
                      renderLabelFunction: RenderStudentStatus,
                      uniqueId: "assignedStatus"
                    },
                    {
                      filterName: "Course Result",
                      optionArr: courseResultAssignedList,
                      state: courseResultAssigned,
                      setState: setCourseResultAssigned,
                      renderLabelFunction: RenderQuizAttemptResultStatus,
                      uniqueId: "assigned"
                    }
                  ]}
                />
              </> : ""}
              <hr />
              <div className="edit-icon new-card-header">
                <div className="card-header">Resources</div>
              </div>
              <div className="row" style={{ paddingBottom: "20px" }}>
                <div className="col-md-6 col-lg-4">
                  <div className="form-icon-group" title="">
                    <div
                      className="prefix-sufix-box"
                      style={{ gap: "16px" }}
                    >
                      <div
                        title="Quiz"
                        style={{
                          zIndex: "inherit",
                          width: "100%",
                          minWidth: "330px",
                          minHeight: "74px",
                          padding: "12px 16px",
                          border: "1px solid #dfe3e6",
                          borderRadius: "10px",
                          boxShadow: "0 2px 3px rgba(0, 0, 0, 0.08)",
                          display: "flex",
                          alignItems: "center",
                          cursor:
                            type !== "add" && assessmentDetails.getSubmissionCount > 0
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          id="quiz1"
                          name="quizCheck"
                          checked={formik.values.assessmentType === "quiz"}
                          onChange={() => {
                            formik.setFieldValue("assessmentType", "quiz");
                            formik.setFieldValue("quizCheck", true);
                            setQuizLabel("");
                            setIsDurationDisabled(true);
                          }}
                          disabled={type !== "add" && assessmentDetails.getSubmissionCount > 0}
                          style={{
                            width: "18px",
                            height: "18px",
                            minWidth: "18px",
                            border: "1px solid #d9dfe3",
                            borderRadius: "50%",
                            margin: "0 16px 0 0",
                            backgroundColor: "#fff",
                            cursor: "inherit",
                          }}
                        />

                        <label
                          htmlFor="quiz1"
                          style={{
                            flex: 1,
                            margin: 0,
                            cursor: "inherit",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            lineHeight: 1.2,
                          }}
                        >
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              // color: "#222",
                              color: tokens.colors.neutral.grey["900"],
                              marginBottom: "3px",
                            }}
                          >
                            Quiz
                          </span>

                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: 400,
                              color: tokens.colors.neutral.grey[500],
                              whiteSpace: "nowrap",
                            }}
                          >
                            Students complete a quiz
                          </span>
                        </label>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: "12px",
                            color: "#20a9c6",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              lineHeight: 1,
                              fontWeight: 400,
                            }}
                          >
                            AB
                          </span>

                          <svg
                            width="14"
                            height="8"
                            viewBox="0 0 14 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L7 7L13 1"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      {/* } */}
                      <div
                        title="Document"
                        style={{
                          zIndex: "inherit",
                          width: "100%",
                          minWidth: "330px",
                          minHeight: "74px",
                          padding: "12px 16px",
                          border: "1px solid #dfe3e6",
                          borderRadius: "10px",
                          boxShadow: "0 2px 3px rgba(0, 0, 0, 0.08)",
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          cursor:
                            type !== "add" && assessmentDetails.getSubmissionCount > 0
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          id="document"
                          name="quizCheck"
                          checked={formik.values.assessmentType === "document"}
                          onChange={() => {
                            formik.setFieldValue("assessmentType", "document");
                            formik.setFieldValue("quizCheck", false);
                            setQuizLabel("");
                            setIsDurationDisabled(false);
                          }}
                          disabled={
                            type !== "add" && assessmentDetails.getSubmissionCount > 0
                          }
                          style={{
                            width: "18px",
                            height: "18px",
                            minWidth: "18px",
                            border: "1px solid #d9dfe3",
                            borderRadius: "50%",
                            margin: "0 16px 0 0",
                            backgroundColor: "#fff",
                            cursor: "inherit",
                          }}
                        />

                        <label
                          htmlFor="document"
                          style={{
                            margin: 0,
                            paddingRight: "40px",
                            cursor: "inherit",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            lineHeight: 1.2,
                          }}
                        >
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              color: "#222",
                              marginBottom: "3px",
                            }}
                          >
                            Document
                          </span>

                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: 400,
                              color: "#777",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Students upload files
                          </span>
                        </label>

                        <i
                          className="fa-light fa-file"
                          style={{
                            position: "absolute",
                            right: "16px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            fontSize: "20px",
                            lineHeight: 1,
                            color: tokens.colors.brand.naartjie["400"],
                          }}
                        />
                      </div>
                      {/* } */}
                      <div
                        title="Embedded PDF"
                        style={{
                          zIndex: "inherit",
                          width: "100%",
                          minWidth: "330px",
                          minHeight: "74px",
                          padding: "12px 16px",
                          border: "1px solid #dfe3e6",
                          borderRadius: "10px",
                          boxShadow: "0 2px 3px rgba(0, 0, 0, 0.08)",
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          cursor:
                            type !== "add" && assessmentDetails.getSubmissionCount > 0
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          id="embeddedPdf"
                          name="quizCheck"
                          checked={formik.values.assessmentType === "embeddedPdf"}
                          onChange={() => {
                            formik.setFieldValue("assessmentType", "embeddedPdf");
                            formik.setFieldValue("quizCheck", false);
                            setQuizLabel("");
                            setIsDurationDisabled(false);
                          }}
                          disabled={
                            type !== "add" && assessmentDetails.getSubmissionCount > 0
                          }
                          style={{
                            width: "18px",
                            height: "18px",
                            minWidth: "18px",
                            border: "1px solid #d9dfe3",
                            borderRadius: "50%",
                            margin: "0 16px 0 0",
                            backgroundColor: "#fff",
                            cursor: "inherit",
                          }}
                        />

                        <label
                          htmlFor="embeddedPdf"
                          style={{
                            margin: 0,
                            paddingRight: "40px",
                            cursor: "inherit",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            lineHeight: 1.2,
                          }}
                        >
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              color: "#222",
                              marginBottom: "3px",
                            }}
                          >
                            Embedded PDF
                          </span>

                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: 400,
                              color: "#777",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Students fill a PDF on the portal
                          </span>
                        </label>

                        <i
                          className="fa-thin fa-pen-field"
                          style={{
                            position: "absolute",
                            right: "16px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            fontSize: "20px",
                            lineHeight: 1,
                            color: tokens.colors.brand["plum-orchid"]["500"],
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              {formik.values.quizCheck && formik.values.assessmentType === "quiz"
                ? (
                  <>
                    <div className="form-group-blk assest-custom-left">
                      <label>Add Quiz *</label>

                      <div className="form-group atttach-file m-0">
                        <Button
                          type="button"
                          variant="primary"
                          size="md"
                          title="Add Quiz"
                          data-toggle={
                            type !== "add" && assessmentDetails.getSubmissionCount > 0 ? "" : "modal"
                          }
                          data-target="#quiz"
                          error={Boolean(
                            formik.errors.quiz_id && formik.touched.quiz_id
                          )}
                          onClick={() => {
                            if (type !== "add" && assessmentDetails.getSubmissionCount > 0) {
                              return;
                            }
                          }}
                        >
                          <i className="fal fa-plus"></i>
                          Add Quiz
                        </Button>
                      </div>
                    </div>

                    <div className="row assest-custom">
                      <div className="col-md-4">
                        <div className="d-flex">
                          <div className="mb-3">
                            {quizLabel && quizFormik.values.quiz_id > 0 && (
                              <>
                                <div className="frm-group">
                                  <ul className="list-unstyled attached-file-ul m-0">
                                    <li>
                                      <a
                                        href={`/courseAdministration/assessment/quizzes/open/details/${quizFormik.values.quiz_id}`}
                                        target="_blank"
                                      >
                                        <i className="fal fa-file"></i>
                                        &nbsp;{" "}
                                        <span title={quizLabel}>
                                          {TrimText(quizLabel, 40)}
                                        </span>
                                      </a>
                                      <button
                                        className="btn btn-danger rounded-circle btn-dropdown-item"
                                        title="Delete"
                                        disabled={type !== "add" && assessmentDetails.getSubmissionCount > 0}
                                        onClick={() => handleQuizDelete()}
                                      >
                                        <i className="fal fa-trash-alt"></i>
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}


              {/* SEND INSTRUCTIONS && MODERATED */}
              {/* HOW DO WE SET type === "open" */}
              <>
                {(formik.values.quizCheck && (formik.values.isHybrid == true || formik.values.isHybrid == "true")) || !formik.values.quizCheck ?
                  <div className="row">
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group-blk mb-3">
                        <MultiSelectDropdown
                          id="Marker"
                          name="Marker"
                          label="Marker"
                          placeholder="Select Marker"
                          options={moderatorAndMarker.sort(
                            sort_by("label", false, (a) => a.toUpperCase())
                          )}
                          value={formik.values.Marker || []}
                          onChange={(event) => {
                            formik.setFieldValue("Marker", event.target.value);
                          }}
                          onBlur={() => formik.setFieldTouched("Marker", true)}
                          error={
                            formik.touched.Marker &&
                            Boolean(formik.errors.Marker)
                          }
                          errorText={
                            formik.touched.Marker
                              ? formik.errors.Marker
                              : undefined
                          }
                          clearable
                        />
                      </div>
                    </div>
                    {type === "open" || formik.values.assessmentType === "embeddedPdf" && (
                      <div className="col-md-2">
                        <div className="form-group-blk mb-3">
                          <label>&nbsp;</label>
                          <div className="form-group form-group-save-cancel">
                            <Button
                              disabled={!formik.values.Marker}
                              variant="primary"
                              type="button"
                              onClick={(e) => handleSendInstruction(e)}
                            >
                              <i className="fal fa-paper-plane" />
                              Send Instruction
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                    {type === "open" || formik.values.assessmentType === "embeddedPdf" && (
                      <div
                        className="custom-check custom-control custom-checkbox mt-2 "
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingBottom: "11px",
                          marginLeft: "0px",
                        }}
                      >
                        <Checkbox
                          id="customCheckModerated"
                          name="select"
                          label="Moderated"
                          checked={formik.values.Moderated == "1"}
                          // disabled={assessmentActive}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "Moderated",
                              e.target.checked ? "1" : "0"
                            );
                            formik.setFieldValue("Moderator", "");
                            setModeratorSelected("");
                          }}
                        />
                      </div>
                    )}
                    {formik.values.Moderated == "1" &&
                      (
                        <div className="col-md-6 col-lg-4">
                          <div className="">
                            <label htmlFor="Moderator">Moderator</label>
                            <div className="form-icon-group mb-4 ">
                              <SelectDropdown
                                name="Moderator"
                                id="Moderator"
                                title="Moderator"
                                placeholder="Select Moderator"
                                options={moderatorAndMarker.sort(myCompare)}
                                value={formik.values.Moderator || ""}
                                onBlur={formik.handleBlur}
                                onChange={(e) => {
                                  const selectedValue = e.target.value;

                                  formik.setFieldValue("Moderator", selectedValue);
                                  setModeratorSelected(selectedValue);
                                }}
                                searchable
                                // clearable
                                maxMenuHeight={175}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                  </div> : null}

                {/* EMBEDDED PDF RADIO SELECTED */}
                {formik.values.assessmentType === "embeddedPdf" && (
                  <>
                    <div className="row assest-custom">

                      {/* Assessment */}
                      <div className="col-md-6 col-lg-4 col-xl-3">
                        <div className="d-flex">
                          <div className="form-group-blk assest-custom-left">
                            <label>Assessment</label>

                            <div className="form-group atttach-file m-0">
                              <label
                                className={
                                  formik.errors.AssessmentFile &&
                                    formik.touched.AssessmentFile
                                    ? "file-req is-invalid"
                                    : ""
                                }
                              >
                                <i className="fal fa-paperclip"></i>
                                <span>Upload</span>

                                <input
                                  ref={assessmentFileInputRef}
                                  disabled={assessmentActive}
                                  type="file"
                                  title="Add Attachment"
                                  className="form-control form-control-aatch-file"
                                  onChange={(e) => {
                                    const file = e.target.files?.[0];

                                    if (!file) return;

                                    setEmbeddedPdfFieldCheckComplete(false);
                                    setEmbeddedPdfFieldCount(0);

                                    formik.setFieldValue("AssessmentFile", file);
                                    setAssessmentFile(file);
                                    setAssessmentFileName(file.name);
                                    setSelectedPdf(file);
                                    // Detect fillable fields immediately after upload
                                    detectPdfFields(file);
                                    formik.setFieldValue("isEmbeddedPdf", true);
                                  }}
                                />
                              </label>
                            </div>
                          </div>
                        </div>

                        {assessmentFileName && (
                          <div
                            className="frm-group"
                          >
                            <ul className="list-unstyled attached-file-ul m-0">
                              <li>
                                <a
                                  title={assessmentFileName}
                                  href={
                                    assessmentFileName.includes("blob") ||
                                      assessmentFileName.startsWith(
                                        "https://s3.af-south-1.amazonaws.com/"
                                      )
                                      ? assessmentFileName
                                      : formatUrl(assessmentFileName)
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <i className="fal fa-file"></i>
                                  &nbsp;
                                  {TrimText(
                                    assessmentFile?.name ??
                                    formik.values.AssessmentFile
                                      ?.split("/")
                                      ?.pop() ??
                                    "",
                                    40
                                  )}
                                </a>

                                <button
                                  className="btn btn-danger rounded-circle btn-dropdown-item"
                                  title="Delete"
                                  onClick={() => handleAssessment()}
                                >
                                  <i className="fal fa-trash-alt"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>

                      {/* Memo */}
                      <div className="col-md-6 col-lg-4 col-xl-3">
                        <div className="d-flex">
                          <div className="form-group-blk assest-custom-left">
                            <label>Memo~~</label>

                            <div className="form-group atttach-file m-0">
                              <label
                                className={
                                  formik.errors.MemoFile &&
                                    formik.touched.MemoFile
                                    ? "file-req is-invalid"
                                    : ""
                                }
                              >
                                <i className="fal fa-paperclip"></i>
                                <span>Upload</span>

                                <input
                                  ref={memoFileInputRef}
                                  disabled={assessmentActive}
                                  type="file"
                                  className="form-control form-control-aatch-file"
                                  title="Add Attachment"
                                  onChange={(e) => {
                                    const file = e.target.files?.[0];

                                    if (!file) return;

                                    formik.setFieldValue("MemoFile", file);
                                    setMemoFile(file);
                                    setMemofileName(file.name);
                                  }}
                                />
                              </label>
                            </div>
                          </div>
                        </div>

                        {memofileName &&
                          memofileName !== "null" &&
                          memofileName !== undefined && (
                            <div
                              className="frm-group"
                            >
                              <ul className="list-unstyled attached-file-ul m-0">
                                <li>
                                  <a
                                    title={memofileName}
                                    href={
                                      memofileName.includes("blob")
                                        ? memofileName
                                        : formatUrl(memofileName)
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <i className="fal fa-file"></i>
                                    &nbsp;
                                    {TrimText(
                                      memoFile?.name
                                        ? memoFile.name
                                        : formik.values.MemoFile
                                          ?.split("/")
                                          .reverse()[0],
                                      40
                                    )}
                                  </a>

                                  <button
                                    className="btn btn-danger rounded-circle btn-dropdown-item"
                                    title="Delete"
                                    onClick={() => handleMemoDelete()}
                                  >
                                    <i className="fal fa-trash-alt"></i>
                                  </button>
                                </li>
                              </ul>
                            </div>
                          )}
                      </div>

                      {/* Share With */}
                      <div className="col-md-6 col-lg-4">
                        <div className="form-group-blk mb-4">
                          <MultiSelectDropdown
                            id="ShareWith"
                            name="ShareWith"
                            label="Share With"
                            placeholder="Select users to share with"
                            options={moderatorAndMarker.sort(myCompare)}
                            value={(formik.values.ShareWith || []).map((value) =>
                              parseInt(value, 10)
                            )}
                            onChange={(event) => {
                              const selectedValues = event.target.value.map((value) =>
                                parseInt(value, 10)
                              );

                              formik.setFieldValue("ShareWith", selectedValues);
                            }}
                            onBlur={() => formik.setFieldTouched("ShareWith", true)}
                            error={
                              formik.touched.ShareWith &&
                              Boolean(formik.errors.ShareWith)
                            }
                            errorText={
                              formik.touched.ShareWith
                                ? formik.errors.ShareWith
                                : undefined
                            }
                          />
                        </div>
                      </div>

                    </div>

                    {/* Embedded PDF Information */}
                    {/* THERE SHOULD PROBABLY BE A CONDITIONAL HERE -- ONLY DISPLAY THIS DIV IF THERE IS AN ASSESSMENT FILE SELECTED */}
                    {assessmentFileName && (
                      <StyledEmbeddedPdfInfo>
                        <StyledEmbeddedPdfInfoContent>
                          <StyledEmbeddedPdfFieldCount>
                            <span>
                              {embeddedPdfFieldCheckComplete && (
                                embeddedPdfFieldCount > 0 ? (
                                  <div>
                                    {embeddedPdfFieldCount} fillable fields detected
                                  </div>
                                ) : (
                                  <div className="invalid-feedback d-block">
                                    No fillable fields were detected in this PDF. Please
                                    upload a PDF containing fillable fields or switch the
                                    submission type to Document.
                                  </div>
                                )
                              )}
                            </span>
                          </StyledEmbeddedPdfFieldCount>

                          <StyledEmbeddedPdfDescription>
                            The attached PDF is embedded on the Student Portal for students
                            to fill in and complete. Their completed PDF is saved as their
                            submission.
                          </StyledEmbeddedPdfDescription>
                        </StyledEmbeddedPdfInfoContent>

                        <StyledPreviewButton
                          type="button"
                          className="btn btn-save btn-success"
                          title="Preview"
                          disabled={!selectedPdf}
                          onClick={() => {
                            setShowPdfPreview(true);
                          }}
                        >
                          <i className="fal fa-eye"></i>
                          Preview
                        </StyledPreviewButton>
                      </StyledEmbeddedPdfInfo>
                    )}
                  </>
                )}

                {/* RADIO DOCUMENT SELECTED */}
                <div className="row assest-custom">
                  {formik.values.assessmentType === "document" && (
                    <>
                      <div className="col-md-6 col-lg-4 col-xl-3">
                        <div className="d-flex">
                          <div className="form-group-blk assest-custom-left">
                            <label>Assessment</label>
                            <div className="form-group atttach-file m-0">
                              <label
                                className={
                                  formik.errors.AssessmentFile &&
                                    formik.touched.AssessmentFile
                                    ? "file-req is-invalid"
                                    : ""
                                }
                              >
                                <i className="fal fa-paperclip"></i>
                                <span>Add Attachment</span>
                                <input
                                  ref={assessmentFileInputRef}
                                  disabled={assessmentActive}
                                  type="file"
                                  title="Add Attachment"
                                  className="form-control form-control-aatch-file"
                                  onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (!file) return;

                                    formik.setFieldValue("AssessmentFile", file);
                                    setAssessmentFile(file);
                                    setAssessmentFileName(file.name);
                                  }}
                                />
                              </label>
                            </div>
                          </div>
                          {/* <button
                            className="btn btn-save btn-success mt-4 ml-3"
                            type="button"
                            title="Browse AMI"
                            disabled={assessmentActive}
                            onClick={() => assessmentFileInputRef.current?.click()}
                          >
                            <i className="fal fa-cloud-download"></i> Browse AMI
                          </button> */}
                        </div>

                        {assessmentFileName && (
                          <>
                            <StyledAttachedFileContainer className="frm-group">
                              <ul className="list-unstyled attached-file-ul m-0">
                                <li>
                                  <a
                                    title={assessmentFileName}
                                    href={
                                      // --- AWS S3 hostname / corona only (before Phase 2 dual-read) ---
                                      // assessmentFileName.includes("blob") || assessmentFileName.startsWith("https://s3.af-south-1.amazonaws.com/")
                                      //   ? assessmentFileName
                                      //   : formatUrl(assessmentFileName)
                                      // Phase 2 dual-read: 1 = S3, 2 = R2, else Library/corona
                                      assessmentFile instanceof File
                                        ? undefined
                                        : getAssignmentDocumentHref(
                                          assessmentFileName,
                                          assessmentDetails?.pathUploadedFrom
                                        )
                                    }
                                    target="_blank"
                                  >
                                    <i className="fal fa-file"></i>
                                    &nbsp;
                                    {TrimText(
                                      assessmentFile instanceof File
                                        ? assessmentFile.name
                                        : (
                                          typeof formik.values.AssessmentFile === "string"
                                            ? formik.values.AssessmentFile.split("/").pop()
                                            : ""
                                        ),
                                      40
                                    )}
                                  </a>
                                  <button
                                    className="btn btn-danger rounded-circle btn-dropdown-item"
                                    title="Delete"
                                    onClick={() => handleAssessment()}
                                  >
                                    <i className="fal fa-trash-alt"></i>
                                  </button>
                                </li>
                              </ul>
                            </StyledAttachedFileContainer>
                          </>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-4 col-xl-3">
                        <div className="d-flex">
                          <div className="form-group-blk">
                            <label>Memo</label>
                            <div className="form-group atttach-file m-0">
                              <label
                                className={
                                  formik.errors.MemoFile &&
                                  formik.touched.MemoFile &&
                                  "file-req is-invalid"
                                }
                              >
                                <i className="fal fa-paperclip"></i>
                                <span>Add Attachment</span>
                                <input
                                  ref={memoFileInputRef}
                                  disabled={assessmentActive}
                                  type="file"
                                  className="form-control form-control-aatch-file"
                                  title="Add Attachment"
                                  onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (!file) return;

                                    formik.setFieldValue("MemoFile", file);
                                    setMemoFile(file);
                                    setMemofileName(file.name);
                                  }}
                                />
                              </label>
                            </div>
                          </div>
                          {/* <button
                            className="btn btn-save btn-success mt-4 ml-3"
                            type="button"
                            title="Browse AMI"
                            disabled={assessmentActive}
                            onClick={() => memoFileInputRef.current?.click()}
                          >
                            <i className="fal fa-cloud-download"></i> Browse AMI
                          </button> */}
                        </div>

                        {memofileName &&
                          memofileName != "null" &&
                          memofileName != undefined && (
                            <>
                              <StyledAttachedFileContainer className="frm-group">
                                <ul className="list-unstyled attached-file-ul m-0">
                                  <li>
                                    <a
                                      title={memofileName}
                                      href={
                                        // --- corona only (before Phase 2 dual-read) ---
                                        // memofileName.includes("blob")
                                        //   ? memofileName : formatUrl(memofileName)
                                        // Phase 2 dual-read: 1 = S3, 2 = R2, else Library/corona
                                        memoFile instanceof File
                                          ? undefined
                                          : getAssignmentDocumentHref(
                                            memofileName,
                                            assessmentDetails?.pathMarkingUploadedFrom
                                          )
                                      }
                                      target="_blank"
                                    >
                                      <i className="fal fa-file"></i>
                                      &nbsp;
                                      {TrimText(
                                        memoFile instanceof File
                                          ? memoFile.name
                                          : (
                                            typeof formik.values.MemoFile === "string"
                                              ? formik.values.MemoFile.split("/").reverse()[0]
                                              : ""
                                          ),
                                        40
                                      )}
                                    </a>
                                    <button
                                      className="btn btn-danger rounded-circle btn-dropdown-item"
                                      title="Delete"
                                      onClick={() => handleMemoDelete()}
                                    >
                                      <i className="fal fa-trash-alt"></i>
                                    </button>
                                  </li>
                                </ul>
                              </StyledAttachedFileContainer>
                            </>
                          )}
                      </div>
                    </>
                  )}

                  {formik.values.assessmentType === "document" || formik.values.assessmentType === "quiz" ?
                    <>
                      <div className="col-md-6 col-lg-4">
                        <div className="form-group-blk mb-4">
                          <MultiSelectDropdown
                            id="shareWith"
                            name="shareWith"
                            label="Share With"
                            placeholder="Select users to share with"
                            options={moderatorAndMarker
                              .sort(myCompare)
                              .map((option) => ({
                                ...option,
                                value: parseInt(option.value, 10),
                              }))}
                            value={(formik.values.shareWith || []).map((value) =>
                              parseInt(value, 10)
                            )}
                            onChange={(event) => {
                              const selectedValues = event.target.value.map((value) =>
                                parseInt(value, 10)
                              );

                              formik.setFieldValue("shareWith", selectedValues);
                            }}
                            onBlur={() => formik.setFieldTouched("shareWith", true)}
                          />
                        </div>
                      </div>
                    </> : null}

                  {/* This is for when QUIZ is selected */}
                  {formik.values.quizCheck ? <>
                    <div className="col-md-6 col-lg-2 offset-lg-4 d-flex" style={{ marginTop: 37 }} title="Require Student Declaration">
                      <label className="mb-0">
                        Require Student Declaration <i className="fal fa-info-circle"></i>
                      </label>
                      <div className="toggle-switch ml-2">
                        <Checkbox
                          id="is_student_signature_required"
                          name="is_student_signature_required"
                          checked={formik.values.is_student_signature_required === 1}
                          onChange={(e) => {
                            formik.setFieldValue("is_student_signature_required", e.target.checked ? 1 : 0);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-2 d-flex" style={{ marginTop: 37 }} title="Require Marker Signature">
                      <label className="mb-0">
                        Require Marker Signature <i className="fal fa-info-circle"></i>
                      </label>
                      <div className="toggle-switch ml-2">
                        <Checkbox
                          id="is_marker_signature_required"
                          name="is_marker_signature_required"
                          checked={formik.values.is_marker_signature_required === 1}
                          onChange={(e) => {
                            formik.setFieldValue("is_marker_signature_required", e.target.checked ? 1 : 0);
                          }}
                        />
                      </div>
                    </div> </> : null}
                </div>
              </>

              <hr />


              {["quiz", "document", "embeddedPdf"].includes(
                formik.values.assessmentType
              ) && (
                  <div
                    style={{
                      width: "100%",
                      marginTop: "24px",
                    }}
                  >
                    {/* Assessment Conditions */}
                    <h4
                      style={{
                        fontSize: "20px",
                        fontWeight: 600,
                        marginBottom: "20px",
                        color: "#222",
                      }}
                    >
                      Assessment Conditions
                    </h4>

                    {/* Time Limit */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "12px",
                        marginBottom: "28px",
                      }}
                    >
                      <label
                        style={{
                          margin: 0,
                          fontSize: "15px",
                          fontWeight: 400,
                          color: "#333",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Time Limit
                      </label>

                      <i
                        className="fal fa-info-circle"
                        title="Set the maximum time allowed for the assessment."
                        style={{
                          fontSize: "15px",
                          color: "#555",
                        }}
                      />

                      {/* Duration Toggle */}
                      <label
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "36px",
                          height: "20px",
                          margin: "0 12px 0 2px",
                          cursor: isDurationDisabled ? "not-allowed" : "pointer",
                          flexShrink: 0,
                        }}
                      >
                        <input
                          type="checkbox"
                          disabled={isDurationDisabled}
                          checked={formik.values.isDuration}
                          onChange={(event) =>
                            formik.setFieldValue("isDuration", event.target.checked)
                          }
                          style={{
                            opacity: 0,
                            width: 0,
                            height: 0,
                          }}
                        />

                        <span
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: formik.values.isDuration
                              ? "#3db5c7"
                              : "#ccc",
                            borderRadius: "20px",
                            transition: "0.2s",
                            cursor: isDurationDisabled ? "not-allowed" : "pointer",
                          }}
                        >
                          <span
                            style={{
                              position: "absolute",
                              height: "16px",
                              width: "16px",
                              left: formik.values.isDuration ? "18px" : "2px",
                              top: "2px",
                              backgroundColor: "#fff",
                              borderRadius: "50%",
                              transition: "0.2s",
                              boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
                            }}
                          />
                        </span>
                      </label>

                      {/* Hours */}
                      <input
                        type="number"
                        min="0"
                        disabled={isDurationDisabled || !formik.values.isDuration}
                        value={formik.values.TimeLimitHours || ""}
                        onChange={(event) =>
                          formik.setFieldValue("TimeLimitHours", event.target.value)
                        }
                        onBlur={formik.handleBlur}
                        name="TimeLimitHours"
                        title="Time Limit Hour"
                        placeholder="1"
                        className={
                          "form-control" +
                          (formik.errors.TimeLimitHours &&
                            formik.touched.TimeLimitHours
                            ? " is-invalid"
                            : "")
                        }
                        style={{
                          width: "84px",
                          height: "44px",
                          borderRadius: "10px",
                          fontSize: "14px",
                        }}
                      />

                      <span
                        style={{
                          fontSize: "15px",
                          fontWeight: 500,
                          color: "#333",
                          marginRight: "4px",
                        }}
                      >
                        hour
                      </span>

                      {/* Minutes */}
                      <input
                        type="number"
                        min="0"
                        max="59"
                        disabled={isDurationDisabled || !formik.values.isDuration}
                        value={formik.values.TimeLimitMinutes || ""}
                        onChange={(event) =>
                          formik.setFieldValue("TimeLimitMinutes", event.target.value)
                        }
                        onBlur={formik.handleBlur}
                        name="TimeLimitMinutes"
                        title="Time Limit Minutes"
                        placeholder="1"
                        className={
                          "form-control" +
                          (formik.errors.TimeLimitMinutes &&
                            formik.touched.TimeLimitMinutes
                            ? " is-invalid"
                            : "")
                        }
                        style={{
                          width: "84px",
                          height: "44px",
                          borderRadius: "10px",
                          fontSize: "14px",
                        }}
                      />

                      <span
                        style={{
                          fontSize: "15px",
                          fontWeight: 500,
                          color: "#333",
                        }}
                      >
                        minutes
                      </span>
                    </div>

                    {/* Monitoring Conditions */}
                    <div style={{ marginBottom: "28px" }}>
                      <CheckboxCardGroup
                        title="Monitoring Conditions"
                        name="MonitoringConditions"
                        columns={4}
                        value={[
                          ...(formik.values.Camera ? ["Camera"] : []),
                          ...(formik.values.ScreenShare ? ["ScreenShare"] : []),
                          ...(formik.values.Audio ? ["Audio"] : []),
                          ...(formik.values.Identification ? ["Identification"] : []),
                        ]}
                        onChange={(selectedValues) => {
                          formik.setFieldValue(
                            "Camera",
                            selectedValues.includes("Camera")
                          );
                          formik.setFieldValue(
                            "ScreenShare",
                            selectedValues.includes("ScreenShare")
                          );
                          formik.setFieldValue(
                            "Audio",
                            selectedValues.includes("Audio")
                          );
                          formik.setFieldValue(
                            "Identification",
                            selectedValues.includes("Identification")
                          );
                        }}
                        options={[
                          {
                            value: "Camera",
                            label: "Webcam Recording",
                            icon: "fa-light fa-camera",
                          },
                          {
                            value: "ScreenShare",
                            label: "Screen Monitoring",
                            icon: "fa-light fa-screencast",
                          },
                          {
                            value: "Audio",
                            label: "Audio Recording",
                            icon: "fal fa-microphone",
                          },
                          {
                            value: "Identification",
                            label: "ID Verification",
                            icon: "fa-thin fa-id-badge",
                          },
                        ]}
                      />
                    </div>

                    {/* Declaration Requirements */}
                    <div style={{ marginBottom: "28px" }}>
                      <div
                        style={{
                          fontSize: "15px",
                          fontWeight: 400,
                          color: "#333",
                          marginBottom: "8px",
                        }}
                      >
                        Declaration Requirements
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                          gap: "10px",
                        }}
                      >
                        <CheckboxCard
                          icon="fal fa-file-signature"
                          label="Student Signature"
                          name="studentSignature"
                          checked={formik.values.studentSignature || false}
                          onChange={(event) =>
                            formik.setFieldValue(
                              "studentSignature",
                              event.target.checked
                            )
                          }
                        />

                        <CheckboxCard
                          icon="fal fa-signature"
                          label="Lecturer Signature"
                          name="lecturerSignature"
                          checked={formik.values.lecturerSignature || false}
                          onChange={(event) =>
                            formik.setFieldValue(
                              "lecturerSignature",
                              event.target.checked
                            )
                          }
                        />
                      </div>
                    </div>

                    {/* Maximum Attempts — quizzes only */}
                    {formik.values.quizCheck === true && (
                      <div className="row">
                        <div className="col-md-6 col-lg-3">
                          <div className="form-group-blk mb-3">
                            <TextInput
                              label="Maximum Attempts"
                              required
                              type="number"
                              title="Maximum Attempts"
                              placeholder="Enter Maximum Attempts"
                              name="maximum_attempts"
                              id="maximum_attempts"
                              value={formik.values.maximum_attempts || ""}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.maximum_attempts &&
                                  formik.errors.maximum_attempts
                                  ? formik.errors.maximum_attempts
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}


              <div className="form-group form-group-save-cancel mt-3 mb-0">
                <div>
                  <PermissionsGate scopes={type === "open" ? ["castedit"] : ["castadd"]} errorProps={{ disabled: true }}>
                    <button
                      className="btn btn-save btn-success"
                      type="submit"
                      title="Save"
                      onClick={() => {
                        if (linkCourseData.length > 0) {
                          formik.setFieldTouched("linkAssessmentCourse", true)

                          setTouchedStates(linkCourseData?.map(() => ({
                            gradeType: true,
                            assessmentTotal: true,
                            passMark: true,
                            weight: true
                          })));
                        }
                      }}
                      // disabled={assessmentLoad || isDisabled ? true : false}
                      disabled={assessmentLoad || isDisabled || embeddedPdfHasNoFields}
                    >
                      {assessmentLoad === false ? (
                        <i className="fal fa-save"></i>
                      ) : (
                        <i className="fas fa-cog fa-spin"></i>
                      )}
                      Save
                    </button>
                  </PermissionsGate>
                  <button
                    className="btn btn-close btn-danger"
                    type="reset"
                    title="Cancel"
                    onClick={() => {
                      if (!formik.dirty) {
                        history.goBack();
                      } else {
                        Swal.fire({
                          title: "Are you sure?",
                          text: "Your work will not be saved",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes, Go Back!",
                        })
                          .then((result) => {
                            if (result.isConfirmed) {
                              history.goBack();
                            }
                          })
                          .catch((error) => {
                            console.error("error: ", error);
                          });
                      }
                    }}
                  >
                    <i className="fal fa-times"></i>Cancel
                  </button>
                </div>
                {Object.keys(formik.values).map((key) => {
                  if (formik.touched[key] && formik.errors[key]) {
                    if (key == "gradeMix") {
                      if (tempCheckedAllData.length) {
                        return gradeMixError.map((item) => {

                          if (!item) {
                            return <></>
                          }
                          return item.errorMessage.map((error) => (
                            <div className="invalid-feedback d-block">
                              {error}
                            </div>
                          ))
                        }
                        );
                      } else {
                        return (
                          <div className="invalid-feedback d-block">
                            {formik.errors[key]}
                          </div>
                        );
                      }
                    } else if (key == "linkAssessmentCourse") {
                      if (linkCourseData.length) {
                        return courseError.map((item, index) => {
                          if (!item) {
                            return null;
                          }

                          const shouldShowGradeTypeError = touchedStates[index]?.gradeType;
                          const shouldShowAssessmentTotalError = touchedStates[index]?.assessmentTotal;
                          const shouldShowPassMarkError = touchedStates[index]?.passMark;
                          const shouldShowweightError = touchedStates[index]?.weight;

                          const filteredErrors = item.errorMessage.filter((error) => {
                            if (error.toLowerCase().includes('grade type') && !shouldShowGradeTypeError) {
                              return false;
                            }
                            if (error.toLowerCase().includes('assessment total') && !shouldShowAssessmentTotalError) {
                              return false;
                            }
                            if (error.toLowerCase().includes('pass mark') && !shouldShowPassMarkError) {
                              return false;
                            }
                            if (error.toLowerCase().includes('Weight') && !shouldShowweightError) {
                              return false;
                            }
                            return true;
                          });

                          if (filteredErrors.length === 0) {
                            return null;
                          }

                          return filteredErrors.map((error, errorIndex) => (
                            <div key={`error-${index}-${errorIndex}`} className="invalid-feedback d-block">
                              {error}
                            </div>
                          ));
                        });
                      } else {
                        return (
                          <div className="invalid-feedback d-block">
                            {formik.errors[key]}
                          </div>
                        );
                      }
                    }
                    return (
                      <div className="invalid-feedback d-block" key={key}>
                        {formik.errors[key]}
                      </div>
                    );
                  }
                })}
              </div>
            </form>
          </div>
        </div>
        {formik.values.quizCheck && <div
          className="topic-add-modal modal able_modal01 fade"
          id="quiz"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered available-assessment-modal"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-body p-0">
                <div className="modal-header modal-header-custom">
                  <h5 className="modal-title">
                    <i className="fal fa-plus"></i> Add Quiz
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <AddQuizzTable addQuizzHandler={addQuizzHandler} />
              </div>
            </div>
          </div>
        </div>}
        {(formik.values.GradeType == 2 || linkCourseData?.some(link => link?.grading_type == 2)) && <ListOfTemplateModal
          setSelectedTemplate={setSelectedTemplate}
          selectedTemplate={selectedTemplate}
          setSelectedGradeMixTemplate={setSelectedGradeMixTemplate}
          letterTemplateCourse={letterTemplateCourse}
          setSelectedCourse={setSelectedCourse}
          selectedCourse={selectedCourse}
          setLetterTemplateCourse={setLetterTemplateCourse}
        />}
        {formik.values.grading_standard === 2 && <ProgrammeGradeMixModal
          setTempCheckedAllData={setTempCheckedAllData}
          tempCheckedAllData={tempCheckedAllData}
          setCheckedAllRows={setCheckedAllRows}
          checkedAllRows={checkedAllRows}
          courseId={id}
          setSelectedGradeMixTemplate={setSelectedGradeMixTemplate}
          quizTotal={quizTotal}
          type={type}
        />}
        <PopupComponent
          id="availableStudents"
          header={{
            iconName: "fa-user-plus",
            heading: "Assign Student"
          }}
          tableData={{
            exportData: exportDataAvailableStd,
            exportFileName: "Assigned_Students",
            data: dataToRenderAvailableStd(),
            columns: studentColumns,
            setSearch: setAvailableSearch,
            search: availableSearch,
            loading: availableLoading,
            filters: [
              {
                filterName: "Status",
                optionArr: statusAvailableList,
                state: statusAvailable,
                setState: setStatusAvailable,
                renderLabelFunction: RenderStudentStatus,
                uniqueId: "availableStatus"
              },
              {
                filterName: "Course Result",
                optionArr: courseResultAvailableList,
                state: courseResultAvailable,
                setState: setCourseResultAvailable,
                renderLabelFunction: RenderQuizAttemptResultStatus,
                uniqueId: "available"
              }
            ]
          }}
        />
        <PopupComponent
          id="overrideMarkFor"
          header={{
            iconName: "fa-exchange",
            heading: "Override Mark For"
          }}
          tableData={{
            exportData: exportDataOverrideFor,
            exportFileName: "Available_assessment",
            data: dataToRenderOverrideAssess(),
            columns: overrideAssessColumns,
            setSearch: setOverrideSearch,
            search: overrideSearch,
            loading: overrideLoading,
            filters: [
              {
                filterName: "Status",
                optionArr: overrideStatusList,
                state: overrideStatus,
                setState: setOverrideStatus,
                renderLabelFunction: RenderAssessmentStatus
              },
              {
                filterName: "Assessment Type",
                optionArr: overrideAssessTypeList,
                state: overrideAssessType,
                setState: setOverrideAssessType,
                renderLabelFunction: RenderAssessmentType
              }
            ]
          }}
        />
        <PopupComponent
          id="availableStudents"
          header={{
            iconName: "fa-user-plus",
            heading: "Assign Student"
          }}
          tableData={{
            exportData: exportDataAvailableStd,
            exportFileName: "Assigned_Students",
            data: dataToRenderAvailableStd(),
            columns: studentColumns,
            setSearch: setAvailableSearch,
            search: availableSearch,
            loading: availableLoading,
            filters: [
              {
                filterName: "Status",
                optionArr: statusAvailableList,
                state: statusAvailable,
                setState: setStatusAvailable,
                renderLabelFunction: RenderStudentStatus,
                uniqueId: "availableStatus"
              },
              {
                filterName: "Course Result",
                optionArr: courseResultAvailableList,
                state: courseResultAvailable,
                setState: setCourseResultAvailable,
                renderLabelFunction: RenderQuizAttemptResultStatus,
                uniqueId: "available"
              }
            ]
          }}
        />
        <PopupComponent
          id="overrideMarkFor"
          header={{
            iconName: "fa-exchange",
            heading: "Override Mark For"
          }}
          tableData={{
            exportData: exportDataOverrideFor,
            exportFileName: "Available_assessment",
            data: dataToRenderOverrideAssess(),
            columns: overrideAssessColumns,
            setSearch: setOverrideSearch,
            search: overrideSearch,
            loading: overrideLoading,
            filters: [
              {
                filterName: "Status",
                optionArr: overrideStatusList,
                state: overrideStatus,
                setState: setOverrideStatus,
                renderLabelFunction: RenderAssessmentStatus
              },
              {
                filterName: "Assessment Type",
                optionArr: overrideAssessTypeList,
                state: overrideAssessType,
                setState: setOverrideAssessType,
                renderLabelFunction: RenderAssessmentType
              }
            ]
          }}
        />
        <PopupComponent
          closeFunction={closeFunction}
          id="assignStudent"
          type="multiple_details_blocks"
          header={{
            iconName: "fa-comment",
            heading: "Appeals"
          }}
          detailsBlocks={[
            {
              heading: "Registered Appeal",
              columns: [
                <div className="col-md-12">
                  <div className="basic-info-box-list modal-info-list">
                    <ul>
                      <li>
                        <span className="title popup-detail-block">
                          Reason for not submitting assessment:{" "}
                        </span>
                        <span className="popup-detail-block">
                          <select
                            className="form-control"
                            name="reason"
                            id="reason"
                            value={appealReason}
                            onChange={e => setAppealReason(e.target.value)}
                          >
                            <option value="Sick" >Sick</option>
                            <option value="Family Responsibility">Family Responsibility</option>
                            <option value="Pre-Arranged Appeal">Pre-Arranged Appeal</option>
                            <option value="Portal Difficulties">Portal Difficulties</option>
                            <option value="Other">Other</option>
                          </select>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>,
                <div className="col-md-12">
                  <div className="basic-info-box-list modal-info-list">
                    <ul>
                      <li>
                        <span className="title popup-detail-block">Description: </span>
                        <span className="text-break popup-detail-block">
                          <div className="fmInput">
                            <textarea className="form-control"
                              onChange={e => setStudentMessage(e.target.value)}
                              value={studentMessage}
                              placeholder="Description"
                              name="description"
                              id="description" />
                          </div>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>,
                <div className="col-md-12">
                  <div className="basic-info-box-list modal-info-list">
                    <ul className="appeal-submission-list">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group-blk mb-3">
                            <li>
                              <span className="title popup-detail-block">
                                Supporting File :
                              </span>
                              <span className="d-block popup-detail-block">
                                <div className="fmInput">
                                  <Dropzone onDrop={acceptedFiles => {
                                    setSelectedFileForAppeal([...selectedFileForAppeal, acceptedFiles[0]])
                                  }} accept=".zip,.jpg,.png,.jpeg,.pdf,.doc,.docx,.txt">
                                    {({ getRootProps, getInputProps }) => (
                                      <section>
                                        <div {...getRootProps()}>
                                          <input {...getInputProps()} />
                                          <p>Drag & drop files here, or click to select files</p>
                                        </div>
                                      </section>
                                    )}
                                  </Dropzone>
                                  {selectedFileForAppeal.map((item, index) => {
                                    return <span key={index}>
                                      <span>
                                        <i className="fal fa-file"></i>
                                        &nbsp;{item.name}
                                      </span>
                                      <button className="btn btn-danger rounded-circle" onClick={() => handleRemoveFile(item)} type="button" title="Delete">
                                        <i className="fal fa-trash-alt"></i>
                                      </button>
                                    </span>
                                  })}
                                </div>
                              </span>
                            </li>
                          </div>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              ]
            },
          ]}
          bottomButton={[
            <button
              type="button"
              className="btn btn-success"
              title="Save"
              onClick={handleSaveAppeal}
            >
              <i className="fal fa-save"></i> Save
            </button>,
            <button
              type="button"
              className="btn btn-danger"
              title="Cancel"
              onClick={closeFunction}
              data-target="#assignStudent"
              data-toggle="modal"
            >
              <i className="fal fa-times"></i> Cancel
            </button>
          ]}
          validationErrorMessage={[
            appealError
          ]}
          otherProps={
            {
              secondPopupCss: "zindexadd appeal-by-admin"
            }
          }
        />
      </div>
      {(intakeDetails && intakeDetails.subject_type !== 'short course') ?
        <LinkCourseModal
          setLinkCourseData={setLinkCourseData}
          linkCourseData={linkCourseData}
          linkCheckedAllRows={linkCheckedAllRows}
          setLinkCheckedAllRows={setLinkCheckedAllRows}
          formik={formik}
          handleRefreshCourseList={handleRefreshCourseList}
          sickAssessmentId={formik.values.override_mark_ass_id}
        />
        : ''}

      {/* Display the Embedded PDF Modal */}
      {showPdfPreview && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
          role="dialog"
          aria-modal="true"
        >
          {/* Padding from the top to fit nicely on the screen */}
          <div
            className="modal-dialog modal-xl"
            style={{
              maxWidth: "90%",
              height: "90vh",
              marginTop: "8vh",
            }}
          >
            <div
              className="modal-content"
              style={{
                height: "100%",
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title">
                  PDF Preview
                </h5>

                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={() => {
                    setShowPdfPreview(false);
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div
                className="modal-body"
                style={{
                  overflow: "auto",
                  padding: "20px",
                }}
              >
                <EmbeddedPdfPreview
                  file={selectedPdf}
                  onFieldCountChange={setEmbeddedPdfFieldCount}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AssessmentForm;
